import {
  Card,
  Row,
  Table,
  Col,
  Input,
  message,
  Spin,
  Modal,
  Image,
  Select,
  Avatar,
  DatePicker,
  Tooltip,
  Popover,
  Dropdown,
  Pagination,
  Menu,
  Button,
  Collapse,
  Typography,
  Tag,
  Empty,
  Tabs,
} from "antd";
import { RiAddBoxFill } from "react-icons/ri";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  ClockCircleOutlined,
  DownOutlined,
  MessageOutlined,
  SearchOutlined,
  CloseOutlined,
  AppstoreOutlined,
  FileTextOutlined,
  MenuOutlined,
  PlusOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import React, { useContext, useEffect, useState, useRef } from "react";
import {
  addFilter,
  deleteFilter,
  deleteTask,
  fetchTasklog,
  getallBoard,
  getallDeveloperForTask,
  getallTask,
  getAllTasksForTableView,
  getFilter,
  updateDeveloperOrder,
  updateFilter,
  updateTask,
  updateTaskOrder,
  transferTasks,
} from "../../utils/API";
import { autoRegisterCurrentPageColumns } from "../../utils/emailTemplateColumns";
import { getErrorMessage } from "../../utils/getErrorMessage";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { ChevronDown, ListTodo, LayoutDashboard, Layout } from "lucide-react";
import TaskFormModal from "./Add";
import EditTaskModal from "./Edit";
import dayjs, { Dayjs } from "dayjs";
import { FaPen, FaTrashAlt } from "react-icons/fa";
import { AuthContext } from "../../Auth/AuthContext";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import axios from "axios";
import DateFilterDropdown from "../../DesignLayout/DateFilterDropdown";
import { useAppDispatch, useAppSelector } from "../store/hooks/redux";
import {
  fetchTasks,
  removeTaskLocal,
  setFilteredTasks,
  updateDeveloperPaginationCurrent,
  updatePaginationCurrent,
  updateTaskLocal,
} from "../store/slice/taskSlice";
import { getStatusFilter } from "../../utils/statusFilter";
import * as Icons from "@ant-design/icons";

dayjs.extend(utc);
dayjs.extend(timezone);

const DraggableRow = (props: any) => {
  const { children, index, ...restProps } = props;
  return (
    <Draggable draggableId={props["data-row-key"]} index={index}>
      {(provided, snapshot) => (
        <tr
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          {...restProps}
          style={{
            ...restProps.style,
            ...provided.draggableProps.style,
            cursor: "move",
            ...(snapshot.isDragging
              ? { position: "relative", zIndex: 9999, background: "#f0f7ff" }
              : {}),
          }}
        >
          {children}
        </tr>
      )}
    </Draggable>
  );
};

interface Task {
  details: any;
  _id: string;
  taskId: string;
  userId: string;
  taskName: string;
  taskDesc: string;
  startDate: string;
  endDate: string;
  deadlineDate: string;
  status: string;
  priority: string;
  assignees: any[];
  reporter: string;
  username: string;
  order?: number;
}

interface Board {
  _id: any;
  name: string;
  slug: string;
}

interface EditTaskModal {
  visible: boolean;
  taskId: string;
  onSuccess: () => void;
  onCancel: () => void;
}

interface LogsApiResponse {
  success: boolean;
  data: any[];
  page: number;
  total: number;
  totalPages: number;
}

interface FilterOptions {
  deadlineDate: [string, string] | null;
}

interface TaskIndexProps {
  onFilterChange: (filters: Partial<FilterOptions>) => void;
}

const STATUS_FILTER_STORAGE_KEY = "statusFilter";
const loadStatusFilterFromStorage = (): string[] => {
  try {
    const saved = localStorage.getItem(STATUS_FILTER_STORAGE_KEY);
    // Case 1: No key exists in localStorage
    if (saved === null) {
      return ["to-do", "in-progress"]; // Return default
    }
    const parsed = JSON.parse(saved);
    // Case 2: Key exists but value is empty array

    if (Array.isArray(parsed) && parsed.length === 0) {
      return ["to-do", "in-progress"]; // Return default instead of empty array
    }

    // Case 3: Key exists with valid non-empty array

    if (Array.isArray(parsed)) {
      return parsed;
    }
    // Case 4: Invalid format (not an array)
    return ["to-do", "in-progress"]; // Fallback to default
  } catch {
    // Case 5: Error parsing
    return ["to-do", "in-progress"]; // Fallback to default
  }
};

export const TaskTable = () => {
  const { RangePicker } = DatePicker;
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [currentTask, setCurrentTask] = useState<Task | null>(null);
  // const [loading, setLoading] = useState(false);
  const [deadline, setDeadline] = useState<[string, string] | null>(null);
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const [searchText, setSearchText] = useState("");
  const modalScrollRef = useRef<HTMLDivElement>(null);
  const [logLoading, setLogLoading] = useState(false);
  const [logSearchText, setLogSearchText] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const IMAGEURL = process.env.REACT_APP_IMAGE_URL + "/developers/";
  const [developerOptions, setDeveloperOptions] = useState<
    {
      photo: string;
      _id: string;
      username: string;
    }[]
  >([]);
  const [selectedTaskDesc, setSelectedTaskDesc] = useState<string | null>(null);
  const [tasklog, setTasklog] = useState<Task[]>([]);
  const [currentTaskLogId, setCurrentTaskLogId] = useState<string>("");
  const [isLogModalOpen, setIsLogModalOpen] = useState(false);
  const [isAddTaskModalOpen, setIsAddTaskModalOpen] = useState(false); // Add this line
  const [defaultBoardId, setDefaultBoardId] = useState<string | null>(null);
  const [selectedTaskLogs, setSelectedTaskLogs] = useState<any[]>([]);
  const [selectedDeveloper, setSelectedDeveloper] = useState<string | null>(
    null,
  );
  const [autoSelect, setAutoSelect] = useState(true);
  const navigate = useNavigate();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const taskId = queryParams.get("id");
  const [boards, setBoards] = useState<any[]>([]);
  const data = localStorage.getItem("authData");
  const { authData } = useContext(AuthContext);
  const isDeveloper = authData.roleId?.roleId === 2;
  const [TaskModal, setTaskModal] = useState(false);
  const isAdmin = authData?.roleId?.roleId === 1;
  const userId = JSON.parse(data || "").user._id || null;
  const userRole = JSON.parse(data || "").roleId || null;
  const [activeKey, setActiveKey] = useState<string[]>([]);
  const [isGroupBy, setIsGroupBy] = useState(true);
  const [isGroupView, setIsGroupView] = useState(true);
  const [selectedLabel, setSelectedLabel] = useState("ðŸ“… Filter by date");
  const [isGroupByExpanded, setIsGroupByExpanded] = useState(true);
  const [favouriteFilters, setFavouriteFilters] = useState<any[]>([]);
  const [selectedFav, setSelectedFav] = useState<undefined | null>(null);
  const [favName, setFavName] = useState("");
  const [selectedIcon, setSelectedIcon] = useState("");
  const [error, setError] = useState("");
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [timeFilter, setTimeFilter] = useState<
    | "today"
    | "yesterday"
    | "last7days"
    | "thisMonth"
    | "lastMonth"
    | "Last3Month"
    | "Last6Month"
    | "custom"
    | undefined
  >(undefined);
  const [showRangePicker, setShowRangePicker] = useState(false);
  const [tempEndDate, setTempEndDate] = useState<Dayjs | null>(null);
  const [tempStartDate, setTempStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  // console.log("isGroupByExpanded", isGroupByExpanded);
  const [expandedKeys, setExpandedKeys] = useState<string[]>([]);
  // console.log("expandedKeys", expandedKeys);
  const [inputValue, setInputValue] = useState("");
  const [selectedStatus, setSelectedStatus] = useState<string[] | null>(null);
  const [selectedAssignees, setSelectedAssignees] = useState();

  const [developers, setDevelopers] = useState<
    { _id: string; username: string }[]
  >([]);
  // State to track the currently applied favourite filter
  const [activeFav, setActiveFav] = useState<any | null>(null);
  const [userStartDate, setUserStartDate] = useState<Dayjs | null>(null);
  const [userEndDate, setUserEndDate] = useState<Dayjs | null>(null);
  const [tempUserStart, setTempUserStart] = useState<Dayjs | null>(null);
  const [tempUserEnd, setTempUserEnd] = useState<Dayjs | null>(null);
  const [userTimeFilter, setUserTimeFilter] = useState<
    | "today"
    | "yesterday"
    | "last7days"
    | "thisMonth"
    | "lastMonth"
    | "Last3Month"
    | "Last6Month"
    | "custom"
    | null
  >(null);

  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  // ADDED: Transfer task UI state
  const [transferModalVisible, setTransferModalVisible] = useState(false);
  const [selectedTargetUserId, setSelectedTargetUserId] = useState<
    string | null
  >(null);
  const [transferLoading, setTransferLoading] = useState(false);
  const [currentDeveloperId, setCurrentDeveloperId] = useState<string | null>(
    null,
  );

  // ADDED: Open transfer modal
  const openTransferModal = (developerId: string) => {
    setCurrentDeveloperId(developerId);
    setSelectedTargetUserId(null);
    setTransferModalVisible(true);
  };

  // ADDED: Handle transfer confirm using transferTasks API
  const handleTransferConfirm = async () => {
    if (!currentDeveloperId || !selectedTargetUserId) {
      message.warning("Please select a target employee");
      return;
    }
    if (currentDeveloperId === selectedTargetUserId) {
      message.warning("Cannot transfer tasks to the same user");
      return;
    }

    const fromDeveloper = developerOptions.find(
      (dev) => dev._id === currentDeveloperId,
    );
    const toDeveloper = developerOptions.find(
      (dev) => dev._id === selectedTargetUserId,
    );

    try {
      setTransferLoading(true);

      // âœ… Use accurate total task count from pagination (all tasks, not just current page)
      const taskCount =
        localDeveloperPaginations[currentDeveloperId]?.total || 0;

      if (taskCount === 0) {
        message.info(
          `No tasks found for ${fromDeveloper?.username} to transfer.`,
        );
        setTransferModalVisible(false);
        setCurrentDeveloperId(null);
        setSelectedTargetUserId(null);
        setTransferLoading(false);
        return;
      }

      // Show loading message
      const loadingMessage = message.loading({
        content: `Transferring ${taskCount} tasks from ${fromDeveloper?.username} to ${toDeveloper?.username}...`,
        duration: 0,
      });

      // âœ… Call the new dedicated transfer endpoint (POST with fromUserId & toUserId)
      const response = await transferTasks(
        currentDeveloperId,
        selectedTargetUserId,
      );

      // Hide loading message
      loadingMessage();

      // âœ… Check response.data.success (backend returns JSON with success flag)
      if (response.data?.success) {
        const transferred = response.data.transferredCount || taskCount;
        message.success({
          content: `Successfully transferred ${transferred} task${transferred !== 1 ? "s" : ""} from ${fromDeveloper?.username} to ${toDeveloper?.username}!`,
          duration: 4,
        });

        // Close modal and reset state
        setTransferModalVisible(false);
        setCurrentDeveloperId(null);
        setSelectedTargetUserId(null);

        // Refresh tasks to reflect changes
        fetchTasksHandler({
          isGroupBy: isGroupView && !taskId && isAdmin,
          page: pagination.current,
          developerId: selectedDeveloper,
          statusFilter: activeFav?.board,
          deadlineDate: deadline || undefined,
        });
      } else {
        throw new Error(response.data?.message || "Transfer failed");
      }
    } catch (error) {
      console.error("Error transferring tasks:", error);
      message.error({
        content: "Failed to transfer tasks. Please try again.",
        duration: 4,
      });
    } finally {
      setTransferLoading(false);
    }
  };

  const userTimeFilterOptions = [
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: "last7days", label: "Last 7 Days" },
    { value: "thisMonth", label: "This Month" },
    { value: "lastMonth", label: "Last Month" },
    { value: "Last3Month", label: "Last 3 Month" },
    { value: "Last6Month", label: "Last 6 Month" },
    ...(userStartDate && userEndDate
      ? [
          {
            value: "custom",
            label: `${userStartDate.format("MMM D")} - ${userEndDate.format(
              "MMM D",
            )}`,
            startDate: userStartDate.format("YYYY-MM-DD"),
            endDate: userEndDate.format("YYYY-MM-DD"),
          },
        ]
      : [
          {
            value: "custom",
            label: "Custom Range",
            startDate: null,
            endDate: null,
          },
        ]),
  ];

  useEffect(() => {
    const checkScroll = () => {
      const scrollEl = scrollRef.current;
      if (!scrollEl) return;

      setCanScrollLeft(scrollEl.scrollLeft > 0);
      setCanScrollRight(
        scrollEl.scrollWidth > scrollEl.clientWidth + scrollEl.scrollLeft,
      );
    };

    // Check initially
    checkScroll();

    // Optional: check on window resize
    window.addEventListener("resize", checkScroll);

    return () => window.removeEventListener("resize", checkScroll);
  }, [favouriteFilters]);

  useEffect(() => {
    const scrollEl = scrollRef.current;
    if (!scrollEl) return;

    const onScroll = () => {
      setCanScrollLeft(scrollEl.scrollLeft > 0);
      setCanScrollRight(
        scrollEl.scrollWidth > scrollEl.clientWidth + scrollEl.scrollLeft,
      );
    };

    scrollEl.addEventListener("scroll", onScroll);

    return () => scrollEl.removeEventListener("scroll", onScroll);
  }, []);

  const updateArrows = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
  };

  useEffect(() => {
    updateArrows();
    const el = scrollRef.current;
    if (!el) return;
    el.addEventListener("scroll", updateArrows);
    window.addEventListener("resize", updateArrows);
    return () => {
      el.removeEventListener("scroll", updateArrows);
      window.removeEventListener("resize", updateArrows);
    };
  }, []);

  const scroll = (direction: "left" | "right") => {
    const el = scrollRef.current;
    if (!el) return;
    const scrollAmount = 180; // width of one tab
    el.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  // const [developerPaginations, setDeveloperPaginations] = useState<any>({
  //   current: 1,
  //   pageSize: 5,
  //   total: 0,
  // });

  const dispatch = useAppDispatch();
  const {
    tasks,
    tasksByDeveloper,
    filteredTasks,
    loading,
    pagination,
    developerPaginations,
  } = useAppSelector((state) => state.tasks);
  // console.log(tasks, "tasks");
  // console.log("tasksByDeveloper", tasksByDeveloper);

  const [statusFilter, setStatusFilter] = useState<string[]>(
    loadStatusFilterFromStorage(),
  );

  const [logsPagination, setLogsPagination] = useState({
    current: 1,
    pageSize: 5, // Fixed at 5 as requested
    total: 0,
  });
  const [descriptionPreviewImage, setDescriptionPreviewImage] = useState<
    string | null
  >(null);

  const handleDescriptionImagePreview = (
    event: React.MouseEvent<HTMLDivElement>,
  ) => {
    const target = event.target as HTMLElement;
    const previewWrapper = target.closest(
      ".description-tooltip-image-preview",
    ) as HTMLElement | null;
    const image =
      (target.closest("img") as HTMLImageElement | null) ||
      (previewWrapper?.querySelector("img") as HTMLImageElement | null);

    if (!image?.src) return;

    event.preventDefault();
    event.stopPropagation();
    setDescriptionPreviewImage(image.currentSrc || image.src);
  };

  const getPreviewableTooltipHtml = (html: string) => {
    const container = document.createElement("div");
    container.innerHTML = html;

    container.querySelectorAll("img").forEach((image) => {
      if (image.parentElement?.classList.contains("description-tooltip-image-preview")) {
        return;
      }

      image.classList.add("description-tooltip-preview-image");
      image.setAttribute("title", "Preview image");

      const wrapper = document.createElement("span");
      wrapper.className = "description-tooltip-image-preview";
      image.parentNode?.insertBefore(wrapper, image);
      wrapper.appendChild(image);

      const icon = document.createElement("span");
      icon.className = "description-tooltip-image-preview-icon";
      icon.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>';
      wrapper.appendChild(icon);
    });

    return container.innerHTML;
  };

  const onFilterChange = (filters: {
    deadlineDate?: [string, string] | [];
  }) => {
    // console.log("Filters applied:", filters);
  };

  const [developerList, setDeveloperList] = useState(developerOptions); // clone developerOptions into state
  const currentUser = () => {
    const data = localStorage.getItem("authData");
    if (!data) return null;
    const parsed = JSON.parse(data);
    return {
      ...parsed.user,
      role: parsed.roleId?.name?.toLowerCase() || "", // injects "admin", "developer", etc.
    };
  };

  const [localTasksByDeveloper, setLocalTasksByDeveloper] =
    useState(tasksByDeveloper);
  const [localDeveloperPaginations, setLocalDeveloperPaginations] =
    useState(developerPaginations);
  const [localFilteredTasks, setLocalFilteredTasks] = useState(filteredTasks);
  useEffect(() => {
    setLocalTasksByDeveloper(tasksByDeveloper);
  }, [tasksByDeveloper]);

  useEffect(() => {
    setLocalDeveloperPaginations(developerPaginations);
  }, [developerPaginations]);

  useEffect(() => {
    setLocalFilteredTasks(filteredTasks);
  }, [filteredTasks]);

  const handleStatusFilterChange = (selectedStatuses: string[]) => {
    // console.log("Selected statuses:", selectedStatuses);

    setStatusFilter(selectedStatuses);

    localStorage.setItem(
      STATUS_FILTER_STORAGE_KEY,
      JSON.stringify(selectedStatuses),
    );

    // Include deadline filter when fetching tasks
    // console.log(" Fetch Task when Filter Local Storage getting")

    fetchTasksHandler({
      isGroupBy: isAdmin ? (isGroupView && !taskId) : false,
      statusFilter: getStatusFilter(),
      deadlineDate: deadline || undefined,
      page: 1,
    });
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      const value = inputValue?.trim();
      if (value) {
        const newFilters = [...statusFilter, value];
        const uniqueFilters = Array.from(new Set(newFilters));
        handleStatusFilterChange(uniqueFilters);
        setInputValue(""); // Clear the input field
      }
    }
  };

  const getStatusOptions = () => {
    // Get board options first

    const boardOptions =
      boards
        ?.filter((board: any) => board.isActive && !board.isDeleted)
        .map((board: any) => ({
          label: board.name,
          value: board.slug,
        })) || [];

    // Default statuses that should always be available

    const defaultStatuses = [
      { label: "To Do", value: "to-do" },
      { label: "In Progress", value: "in-progress" },
    ];

    // Custom statuses that aren't already board slugs

    const customStatuses = statusFilter
      .filter(
        (status) =>
          !boards?.some((board) => board.slug === status) &&
          !defaultStatuses.some((s) => s.value === status),
      )

      .map((status) => ({
        label: status,
        value: status,
      }));

    // Combine all options, ensuring defaults are first and unique

    const allOptions = [...defaultStatuses, ...boardOptions, ...customStatuses];

    // Remove duplicates by value

    const uniqueOptions = allOptions.filter(
      (option, index, self) =>
        index === self.findIndex((o) => o.value === option.value),
    );
    return uniqueOptions;
  };

  const toggleExpand = (key: string) => {
    setExpandedKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key],
    );
  };

  // when developerOptions change, expand all by default

  useEffect(() => {
    if (developerOptions.length > 0) {
      setExpandedKeys(developerOptions.map((d: any) => d._id));
      setIsGroupByExpanded(true);
    }
  }, [developerOptions]);

  // toggle expand/collapse all

  const handleGroupExpandToggle = () => {
    if (isGroupByExpanded) {
      // collapse all
      setExpandedKeys([]);
    } else {
      // expand all
      setExpandedKeys(developerList.map((d: any) => d._id));
    }
    setIsGroupByExpanded(!isGroupByExpanded);
  };

  // const handleDateFilterSelect = (
  //   selectedOption: string,
  //   customRange?: [Dayjs, Dayjs]
  // ) => {
  //   let startDate: Dayjs | null = null;
  //   let endDate: Dayjs | null = dayjs();
  //   if (selectedOption === "Clear") {
  //     setSelectedLabel("ðŸ“… Filter by date");
  //     setDeadline(null);
  //     onFilterChange({ deadlineDate: undefined });
  //     return;
  //   }

  //   if (selectedOption === "Custom Range" && customRange) {
  //     startDate = customRange[0];
  //     endDate = customRange[1];
  //     setSelectedLabel(
  //       `${startDate.format("MMM D")} - ${endDate.format("MMM D")}`
  //     );
  //   } else {
  //     setSelectedLabel(selectedOption);
  //     switch (selectedOption) {
  //       case "Today":
  //         startDate = dayjs().startOf("day");
  //         break;
  //       case "Yesterday":
  //         startDate = dayjs().subtract(1, "day").startOf("day");
  //         endDate = dayjs().subtract(1, "day").endOf("day");
  //         break;
  //       case "Last 7 Days":
  //         startDate = dayjs().subtract(7, "days").startOf("day");
  //         break;
  //       case "This Month":
  //         startDate = dayjs().startOf("month");
  //         break;
  //       case "Last Month":
  //         startDate = dayjs().subtract(1, "month").startOf("month");
  //         endDate = dayjs().subtract(1, "month").endOf("month");
  //         break;
  //       default:
  //         return;
  //     }
  //   }

  //   const formatted: any = [
  //     startDate.format("DD-MM-YYYY"),
  //     endDate.format("DD-MM-YYYY"),
  //   ];
  //   setDeadline(formatted);
  //   onFilterChange({ deadlineDate: formatted });
  // };

  useEffect(() => {
    const fetchBoards = async () => {
      try {
        const response = await getallBoard("", 1);
        setBoards(response.data);
        if (response.data.length > 0) {
          setDefaultBoardId(response.data[0]._id);
        }
      } catch (error) {
        console.error("Error fetching boards:", error);
      }
    };
    const fetchDevelopers = async () => {
      try {
        const response: any = await getallDeveloperForTask("", "");
        setDevelopers(response?.data || []);
      } catch {
        message.error("Failed to load developers");
        setDevelopers([]);
      }
    };
    fetchBoards();
    fetchDevelopers();
  }, []);

  useEffect(() => {
    setDeveloperList(developerOptions); // Update when props change
  }, [developerOptions]);

  const handleDeveloperDragEnd = async (result: any) => {
    if (!result.destination) return;
    const newOrder = Array.from(developerOptions);
    const [moved] = newOrder.splice(result.source.index, 1);
    newOrder.splice(result.destination.index, 0, moved);
    // Update the order fields based on new positions
    const updatedOrder = newOrder.map((dev, index) => ({
      ...dev,
      order: index,
    }));

    // Sort again to be safe

    const sortedOrder = updatedOrder.sort((a, b) => a.order - b.order);
    setDeveloperOptions(sortedOrder);
    try {
      const orderedIds = sortedOrder.map((dev) => dev._id);
      await updateDeveloperOrder(orderedIds);
      // --- COMMON LOGIC ---
      const statusFilter = activeFav?.board;

      const developerId = activeFav?.assignees?.length
        ? activeFav.assignees[0]
        : selectedDeveloper;

      let deadlineDate: any = null;

      // --- ADMIN / FAV LOGIC ---
      if (isAdmin) {
        if (activeFav?.time === "custom") {
          deadlineDate = {
            type: "custom",
            startDate: activeFav.startDate,
            endDate: activeFav.endDate,
          };
        } else {
          deadlineDate = activeFav?.time || undefined;
        }

        fetchTasksHandler({
          isGroupBy: true,
          deadlineDate,
          page: pagination.current,
          developerId,
          statusFilter: statusFilter,
          startDate: activeFav?.startDate,
          endDate: activeFav?.endDate,
        });
      }
    } catch (error) {
      console.error("Failed to update developer order", error);
    }
  };

  const fetchBoards = async () => {
    try {
      const response = await getallBoard("", 1);
      setBoards(response?.data || []); // âœ… use response.data directly
    } catch (err) {
      console.error("Failed to fetch boards", err);
      setBoards([]);
    }
  };

  const fetchTasksHandler = async (params: any = {}) => {
    const statusFilter =
      params.statusFilter !== undefined
        ? params.statusFilter
        : activeFav?.board?.length
          ? activeFav.board
          : undefined;

    const developerId =
      params.developerId !== undefined
        ? params.developerId
        : activeFav?.assignees?.length
          ? activeFav.assignees
          : selectedDeveloper;

    let deadlineDate: any = null;

    if (params?.deadlineDate === "custom") {
      deadlineDate = {
        type: "custom",
        startDate: params?.startDate || activeFav?.startDate,
        endDate: params?.endDate || activeFav?.endDate,
      };
    } else {
      // console.log("main Fetch Function", params.deadlineDate, activeFav?.time)
      deadlineDate = params?.deadlineDate;
    }
    // console.log("main Fetch Function", params)

    await dispatch(
      fetchTasks({
        isGroupBy:
          params.isGroupBy !== undefined
            ? params.isGroupBy
            : isGroupView && !taskId && isAdmin,
        page: params.page !== undefined ? params.page : pagination.current,
        developerId,
        deadlineDate,
        statusFilter: statusFilter,
        searchText:
          params.searchText !== undefined ? params.searchText : searchText,
        taskId: params.taskId !== undefined ? params.taskId : taskId || undefined,
      }),
    );
  };

  useEffect(() => {
    if (selectedFav === null) {
      fetchTasksHandler({
        searchText,
        isGroupBy: isGroupView && !taskId && isAdmin,
        page: pagination.current,
      });
    }
    // console.log("Use Effect Fetch")

    fetchLogs();
  }, [
    searchText,
    isGroupView,
    deadline,
    selectedDeveloper,
    isAdmin,
    selectedAssignees,
    activeFav,
    search,
  ]);

  useEffect(() => {
    if (!userTimeFilter) return;

    const filterPayload =
      userTimeFilter === "custom" && userStartDate && userEndDate
        ? {
            deadlineDate: {
              type: "custom",
              startDate: userStartDate.format("YYYY-MM-DD"),
              endDate: userEndDate.format("YYYY-MM-DD"),
            },
          }
        : { deadlineDate: userTimeFilter };
    // console.log("for the user")
    fetchTasksHandler({
      ...filterPayload,
      page: pagination.current,
    });
  }, [userTimeFilter, userStartDate, userEndDate]);

  const fetchLogs = async (taskId: string = "", page = 1) => {
    try {
      setLogLoading(true);
      if (taskId) {
        setIsLogModalOpen(true);
        setCurrentTaskLogId(taskId);
      }

      const response: any = await fetchTasklog(
        taskId,
        page,
        "",
        5, // Explicitly pass pageSize of 5
      );

      if (taskId) {
        // Filter out duplicate logs based on message
        const uniqueLogs = response.data.filter(
          (log: any, index: number, self: any[]) =>
            index === self.findIndex((l: any) => l.message === log.message),
        );
        setSelectedTaskLogs(uniqueLogs);
        // Update pagination state with API response
        setLogsPagination({
          current: response.page || 1,
          pageSize: 5, // Keep fixed at 5
          total: response.total || 0,
        });
      } else {
        setTasklog(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching logs:", error);
      message.error("Failed to fetch logs. Please try again.");
      setSelectedTaskLogs([]);
    } finally {
      setLogLoading(false);
    }
  };

  const handleViewLogs = (taskId: string, page = 1) => {
    setCurrentTaskLogId(taskId);
    setLogsPagination((prev) => ({
      ...prev,
      current: page,
      pageSize: 5, // Explicitly set pageSize to 5
    }));
    fetchLogs(taskId, page);
  };

  // Fetch developers for dropdown options

  const fetchDevelopers = async () => {
    try {
      const response: any = await getallDeveloperForTask("", "");
      if (response?.data) {
        // Sort developers by their order field
        const sortedDevelopers = response.data.sort(
          (a: any, b: any) => a.order - b.order,
        );
        // store the developer in local storage
        localStorage.setItem(
          "developerOptions",
          JSON.stringify(sortedDevelopers),
        );
        setDeveloperOptions(sortedDevelopers);
      } else {
        setDeveloperOptions([]);
      }
    } catch (error) {
      console.error("Error fetching developers:", error);
    }
  };

  useEffect(() => {
    fetchDevelopers();
  }, []);
  const handleEditTask = (record: Task) => {
    setCurrentTask(record);
    setIsEditModalVisible(true);
  };

  const handleUpdateTask = () => {
    setIsEditModalVisible(false);
  };

  // Handle Delete Confirmation
  const handleDeleteConfirmation = (id: string) => {
    setDeleteId(id);
  };

  // Handle Delete Action

  const handleDelete = async () => {
    if (!deleteId) return;
    const task = filteredTasks.find((t) => t._id === deleteId);
    const developerId = task?.assignees?.[0]?._id; // adjust if multiple
    dispatch(removeTaskLocal({ taskId: deleteId, developerId }));
    setDeleteId(null);
    try {
      const response = await deleteTask(deleteId, true);
      if (response) {
        message.success("Task deleted successfully");
      } else {
        throw new Error("Failed to delete task");
      }
    } catch (error) {
      message.error("Error deleting task. Reverting changes...");
      // console.log(" Fetch Task when delete Task")

      fetchTasksHandler({
        isGroupBy: isGroupView,
        statusFilter: isAdmin ? "" : getStatusFilter(),
        deadlineDate: deadline || undefined,
        developerId: null,
        page: pagination.current,
      });
    }
  };

  const handleUpdate = async (
    taskId: string,
    field: string,
    updatedValue: any,
    label?: string,
  ) => {
    try {
      let updatePayload: any = {};
      if (field === "status") {
        const selectedBoard = boards.find((b: any) => b.slug === updatedValue);
        // console.log("selectedBoard", selectedBoard);
        if (selectedBoard) {
          updatePayload = {
            status: updatedValue,
            boardId: selectedBoard._id,
          };
          const task = filteredTasks.find((task) => task._id === taskId);
          // console.log("updatedValue", updatedValue);
          if (updatedValue === "in-progress" && !task?.startDate) {
            updatePayload.startDate = new Date().toISOString();
          } else if (updatedValue === "completed") {
            if (!task?.startDate) {
              updatePayload.startDate = new Date().toISOString();
            }
            if (!task?.endDate) {
              updatePayload.endDate = new Date().toISOString();
            }
          }
        }
      } else if (field === "boardId") {
        const selectedBoard = boards.find((b: any) => b._id === updatedValue);
        if (selectedBoard) {
          updatePayload = {
            boardId: updatedValue,
            status: selectedBoard.name,
          };
          const task = filteredTasks.find((task) => task._id === taskId);
          // console.log("Selected board", selectedBoard);
          if (selectedBoard.name === "In Progress" && !task?.startDate) {
            updatePayload.startDate = new Date().toISOString();
          } else if (selectedBoard.name === "Completed") {
            if (!task?.startDate) {
              updatePayload.startDate = new Date().toISOString();
            }
            if (!task?.endDate) {
              updatePayload.endDate = new Date().toISOString();
            }
          }
        }
      } else {
        updatePayload[field] = updatedValue;
      }
      // Update locally first for immediate UI response
      dispatch(updateTaskLocal({ taskId, updates: updatePayload }));
      // Then call API in background
      const response = await updateTask(taskId, updatePayload);
      // If API call fails, revert the local change
      if (!response || response.status !== 200) {
        throw new Error("API update failed");
      }
      // If API succeeds, update with the complete response data
      dispatch(updateTaskLocal({ taskId, updates: response.data }));
      message.success(`Task updated successfully!`);
    } catch (error) {
      console.error(`Error updating ${field}`, error);
      message.error(`Failed to update ${label || field}`);
      // Revert to original state by refetching
      //console.log(" Fetch Task when Update Task");

      fetchTasksHandler({
        isGroupBy: autoSelect,
        // statusFilter: getStatusFilter(),
        // deadlineDate: deadline || undefined,
        developerId: null,
        page: pagination.current,
      });
    }
  };

  const filterFetch = async () => {
    try {
      const localFilters = getFavouriteFilters(); // âœ… already only Analytics if you fixed earlier
      if (isDeveloper) {
        return;
      }
      const response = await getFilter(); // API call
      // âœ… filter server response by Analytics type
      const serverFilters = Array.isArray(response?.data)
        ? response.data.filter((res: any) => res.type === "Task")
        : response?.data?.type === "Task"
          ? [response.data]
          : [];
      // âœ… only keep filters for current user
      const userId = authData?.user?._id;
      const userFilters = serverFilters.filter(
        (sf: any) => sf.userId === userId,
      );
      // âœ… merge local + server (avoid duplicates by _id)
      const mergedFilters = [
        ...localFilters,
        ...userFilters.filter(
          (sf: any) => !localFilters.some((lf) => lf._id === sf._id),
        ),
      ];
      // âœ… save merged into localStorage
      saveFavouriteFilters(mergedFilters);
      setFavouriteFilters(mergedFilters);
    } catch (error) {
      console.error("Failed to fetch filters:", error);
    }
  };

  useEffect(() => {
    filterFetch();
  }, []);

  const timeFilterOptions = [
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: "last7days", label: "Last 7 Days" },
    { value: "thisMonth", label: "This Month" },
    { value: "lastMonth", label: "Last Month" },
    { value: "Last3Month", label: "Last 3 Month" },
    { value: "Last6Month", label: "Last 6 Month" },
    ...(startDate && endDate
      ? [
          {
            value: "custom",
            label: `${startDate.format("MMM D")} - ${endDate.format("MMM D")}`,
            startDate: startDate.format("DD-MM-YYYY"),
            endDate: endDate.format("DD-MM-YYYY"),
          },
        ]
      : [
          {
            value: "custom",
            label: "Custom Range",
            startDate: null,
            endDate: null,
          },
        ]),
  ];

  const resetSettings = () => {
    // setSelectedSource([]);
    setTimeFilter(undefined);
    setStartDate(null);
    setEndDate(null);
    setTempStartDate(null);
    setShowRangePicker(false);
    setSelectedStatus([]);
    setSelectedAssignees(undefined);
    setFavName("");
    setError("");
  };

  const iconKeys = Object.keys(Icons).filter(
    (key) => key.endsWith("Outlined"), // only outlined icons (you can adjust)
  );

  const options = iconKeys.map((key) => {
    const IconComp = (Icons as any)[key];
    return {
      label: (
        <span>
          <IconComp style={{ marginRight: 8 }} /> {key}
        </span>
      ),
      value: key,
    };
  });

  const onDragEndFilter = (result: any) => {
    if (!result.destination) return;
    const reordered = Array.from(favouriteFilters);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);
    saveFilterOrder(reordered); // ðŸ‘ˆ updates backend + localStorage
  };

  const FILTER_STORAGE_KEY = "TaskFilter";
  const saveFavouriteFilters = (filters: any[]) => {
    try {
      // âœ… only save Analytics type filters
      const Task = filters.filter((f: any) => f.type === "Task");
      localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(Task));
    } catch (error) {
      console.error("Failed to save favourite filters to localStorage", error);
    }
  };

  const getFavouriteFilters = (): any[] => {
    try {
      const saved = localStorage.getItem(FILTER_STORAGE_KEY);
      const parsed = saved ? JSON.parse(saved) : [];
      return parsed.filter((f: any) => f.type === "Task");
    } catch (error) {
      console.error(
        "Failed to parse favourite filters from localStorage",
        error,
      );
      return [];
    }
  };

  const deleteFavouriteFilter = async (id: any) => {
    try {
      await deleteFilter(id);

      const filters = getFavouriteFilters().filter((f) => f._id !== id);
      saveFavouriteFilters(filters);
      setFavouriteFilters(filters);
      // âœ… reset selectedFav if deleted
      if (selectedFav === id) {
        setSelectedFav(null);
        localStorage.removeItem("selectedFavId");
      }
      message.success("Favourite filter deleted!");
    } catch (error) {
      console.error("Failed to delete filter:", error);
      message.error("Failed to delete favourite filter!");
    }
  };

  const saveFilterOrder = async (newOrder: any[]) => {
    try {
      const updatedFilters = newOrder.map((filter, index) => ({
        ...filter,
        orderId: index + 1,
      }));

      // ðŸ” Update one by one

      await Promise.all(
        updatedFilters.map((f) =>
          updateFilter(f._id, { orderId: f.orderId, type: "Task" }),
        ),
      );
      // âœ… Update local state + localStorage
      setFavouriteFilters(updatedFilters);
      saveFavouriteFilters(updatedFilters);
    } catch (error) {
      console.error("Failed to save filter order:", error);
    }
  };

  const applyFavouriteFilter = (fav: any) => {
    if (selectedFav === fav._id) {
      // Deselect favourite
      setSelectedFav(null);
      setActiveFav(null);
      setSelectedDeveloper(null);
      //console.log("Fetch Task when Filter Unselect");

      // fetchTasksHandler({
      //   isGroupBy: isGroupView && isAdmin,
      //   developerId: selectedDeveloper,
      //   deadlineDate: deadline || undefined,
      //   page: 1,
      //   searchText,
      // });
      return;
    }

    setSelectedFav(fav._id);
    setActiveFav(fav);

    if (fav.assignees?.length) {
      setSelectedDeveloper(fav.assignees[0]);
    } else {
      setSelectedDeveloper(null);
    }

    //console.log("Fetch Task when Filter select");

    fetchTasksHandler({
      isGroupBy: isGroupView && !taskId && isAdmin,
      page: 1,
      statusFilter: fav?.board,
      developerId: fav.assignees ? fav.assignees[0] : selectedDeveloper,
      deadlineDate: fav.time || undefined,
      startDate: fav.startDate || undefined,
      endDate: fav.endDate || undefined,
      searchText,
    });
  };

  const addFavouriteFilter = async (fav: any) => {
    if (!fav.name.trim()) {
      setError("Please enter favorite name!");
      return;
    }

    setError("");
    const filters = getFavouriteFilters();
    const payload = {
      type: "Task",
      userId: userId || null,
      icon: fav.icon || "",
      name: fav.name,
      time: timeFilter || null,
      startDate: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
      endDate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null,
      board: Array.isArray(selectedStatus)
        ? selectedStatus
        : selectedStatus
          ? [selectedStatus]
          : null,
      assignees: selectedAssignees
        ? selectedAssignees
        : selectedAssignees
          ? selectedAssignees
          : null,
      isActive: true,
      isDeleted: false,
    };

    try {
      // send payload to backend
      const response = await addFilter(payload);
      // build slug (unique identifier for query params)
      const slug = fav.name.toLowerCase().replace(/s+/g, "-");
      // build saved filter
      const savedFilter = {
        ...payload,
        _id: response.data?._id,
        slug,
      };

      // save in local storage / state

      // filters.push(savedFilter);

      const updatedFilters = [...filters, savedFilter];
      saveFavouriteFilters(updatedFilters);
      setFavouriteFilters(updatedFilters);
      message.success("Favourite filter saved!");
    } catch (error) {
      console.error("Failed to save filter:", error);
      message.error("Failed to save favourite filter!");
    }
  };

  const TaskMenu = (
    <div
      style={{
        display: "flex",
        maxWidth: "750px", // â¬… increased width
        background: "linear-gradient(145deg, #ffffff, #f8fafc)",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        borderRadius: "12px",
        overflow: "hidden",
        padding: "16px",
        gap: "20px",
        height: "60vh", // â¬… increased height for modal
      }}
    >
      {/* -------- Favorites Section -------- */}
      <div
        style={{
          flex: 1,
          padding: "12px",
          border: "1px solid #e5e7eb",
          borderRadius: "8px",
          background: "#fff",
          overflowY: "auto", // â¬… scroll if filters overflow
          maxHeight: "calc(85vh - 40px)",
        }}
      >
        <DragDropContext onDragEnd={onDragEndFilter}>
          <Droppable droppableId="droppable">
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                <Table
                  dataSource={favouriteFilters}
                  rowKey={(record: any) => record._id || record.id} // ensure unique key
                  pagination={false}
                  size="small"
                  style={{ marginTop: "12px" }}
                  columns={[
                    {
                      title: "Favorites",
                      dataIndex: "name",
                      key: "name",
                      render: (_: any, record: any, index: number) => {
                        const IconComp = (Icons as any)[record.icon];
                        return (
                          <Draggable
                            draggableId={record._id}
                            index={index}
                            key={record._id}
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  cursor: "grab",
                                  ...provided.draggableProps.style,
                                }}
                                onClick={() => applyFavouriteFilter(record)}
                              >
                                {IconComp && (
                                  <IconComp style={{ fontSize: "16px" }} />
                                )}

                                {/* <Tooltip
                                   title={record.name}
                  color="#CCCCCC"
                  overlayInnerStyle={{ color: "#000", padding: "12px" }}

                                 > */}
                                <span
                                  style={{
                                    flex: 1,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    maxWidth: "200px",
                                  }}
                                >
                                  {record.name}
                                </span>
                                {/* </Tooltip > */}
                              </div>
                            )}
                          </Draggable>
                        );
                      },
                    },

                    {
                      title: "Action",
                      key: "action",
                      align: "center",
                      width: 80,
                      render: (_: any, record: any) => (
                        <Icons.DeleteOutlined
                          onClick={(e) => {
                            e.stopPropagation();
                            deleteFavouriteFilter(record._id);
                          }}
                          style={{ color: "#ef4444", cursor: "pointer" }}
                        />
                      ),
                    },
                  ]}
                />
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>

      {/* -------- Filters Section -------- */}

      <div
        style={{
          padding: "12px",
          border: "1px solid #e5e7eb",
          borderRadius: "8px",
          background: "#fff",
          overflowY: "auto", // â¬… scroll if filters overflow
          maxHeight: "calc(85vh - 40px)",
        }}
      >
        <h4
          style={{
            fontWeight: 600,
            fontSize: "16px",
            marginBottom: "12px",
            color: "#1f2937",
          }}
        >
          Filters
        </h4>

        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <div style={{ display: "flex", gap: "8px" }}>
            {/* --- Icon Select --- */}
            <Tooltip
              title="Select an Icon"
              color="#CCCCCC"
              overlayInnerStyle={{
                color: "#000", // âœ… font color
                padding: "12px",
              }}
            >
              <Select
                style={{ width: 80, marginTop: "5px" }}
                showSearch
                placeholder="Select Icon"
                value={selectedIcon}
                onChange={(val) => setSelectedIcon(val)}
                optionFilterProp="children"
                dropdownMatchSelectWidth={false}
                onClick={(e) => e.stopPropagation()}
                options={options}
              />
              {/* {iconKeys.map((key) => {
                                     const IconComp = (Icons as any)[key];
        return (
        <Option key={key} value={key}>
          <IconComp style={{ marginRight: 8 }} /> {key}
        </Option>
        );
                                 })} */}
              {/* </Select > */}
            </Tooltip>
            {/* --- Name Input --- */}
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Input
                placeholder="Enter favorite name"
                className="Allinput"
                value={favName}
                onChange={(e) => setFavName(e.target.value)}
              />
	              {error && (
	                <span
	                  style={{ color: "red", fontSize: "12px", marginTop: "16px" }}
	                >
	                  {getErrorMessage(error)}
	                </span>
	              )}
            </div>
            {/* --- Save Button --- */}
          </div>

          <Select
            mode="tags"
            style={{ width: "100%", height: "33px" }}
            placeholder="Filter by status"
            value={selectedStatus} // bind state
            onChange={(val) => setSelectedStatus(val)} // update state
            options={getStatusOptions()}
            inputValue={inputValue}
            onSearch={(val) => setInputValue(val)}
            showSearch
            maxTagCount="responsive"
            className="min-w-[110px] asjdlaskjaslkd"
            tagRender={({ label, value, closable, onClose }) => (
              <Tag closable={closable} onClose={onClose}>
                {label}
              </Tag>
            )}
          />

          <Select
            value={selectedAssignees} // bind state
            onChange={(val) => setSelectedAssignees(val)}
            mode="multiple"
            placeholder="Select Assignees"
            filterOption={(input, option) =>
              (option?.children ?? "")
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {developers.map((dev) => (
              <Select.Option key={dev._id} value={dev._id}>
                {dev.username}
              </Select.Option>
            ))}
          </Select>

          <Select
            style={{ width: "100%", height: "33px" }}
            value={timeFilter}
            onChange={(value, option) => {
              setTimeFilter(value);
              // setPage(1);
              if (value === "custom") {
                if (
                  option &&
                  !Array.isArray(option) &&
                  (option as { startDate?: string; endDate?: string })
                    .startDate &&
                  (option as { startDate?: string; endDate?: string }).endDate
                ) {
                  // directly set range from option
                  setStartDate(
                    dayjs((option as { startDate: string }).startDate),
                  );
                  setEndDate(dayjs((option as { endDate: string }).endDate));
                } else {
                  // show picker if not yet selected
                  setShowRangePicker(true);
                }
              } else {
                setStartDate(null);
                setEndDate(null);
                setTempStartDate(null);
                setTempEndDate(null);
                setShowRangePicker(false);
              }
            }}
            placeholder="Select Time Filter"
            allowClear
            options={timeFilterOptions}
            optionLabelProp="label"
            dropdownRender={(menu) => (
              <div>
                {menu}

                <div style={{ textAlign: "center" }}>
                  <Button
                    type="link"
                    style={{ color: "red" }}
                    onClick={() => {
                      setTimeFilter(undefined);
                      setStartDate(null);
                      setEndDate(null);
                      setTempStartDate(null);
                      setTempEndDate(null);
                      setShowRangePicker(false);
                    }}
                  >
                    Clear All Filters
                  </Button>
                </div>
              </div>
            )}
          />

          {showRangePicker && (
            <div
              style={{
                position: "fixed",
                top: "25%",
                left: "70%",
                transform: "translate(-50%, -50%)",
                zIndex: 1500,
                background: "#fff",
                padding: "16px",
                boxShadow:
                  "0 3px 6px -4px rgba(0,0,0,0.12), 0 6px 16px 0 rgba(0,0,0,0.08), 0 9px 28px 8px rgba(0,0,0,0.05)",
                borderRadius: "8px",
                width: "fit-content",
              }}
            >
              <DatePicker.RangePicker
                value={
                  tempStartDate && tempEndDate
                    ? [tempStartDate, tempEndDate]
                    : null
                }
                onChange={(dates) => {
                  setTempStartDate(dates ? dates[0] : null);
                  setTempEndDate(dates ? dates[1] : null);
                }}
                format="YYYY-MM-DD"
                style={{ marginBottom: "16px", width: "100%" }}
                allowClear={false}
                getPopupContainer={(triggerNode) => document.body}
                popupStyle={{ zIndex: 2000 }} // make sure itâ€™s above your box
              />

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "8px",
                }}
              >
                <Button
                  onClick={() => {
                    setShowRangePicker(false);
                    setTempStartDate(null);
                    setTempEndDate(null);
                    setTimeFilter(undefined);
                    setStartDate(null);
                    setEndDate(null);
                  }}
                >
                  Cancel
                </Button>

                <Button
                  className="allbuttons text-white deal-apply"
                  onClick={() => {
                    if (tempStartDate && tempEndDate) {
                      setStartDate(tempStartDate);
                      setEndDate(tempEndDate);
                      setShowRangePicker(false);
                      setTimeFilter("custom");
                    }
                  }}
                >
                  Apply
                </Button>
              </div>
            </div>
          )}

          <div className="position-absolute right-6 bottom-5 flex justify-end items-end mt-1">
            {/* <Tooltip title="Save" olor="#CCCCCC"
                   overlayInnerStyle={{
      color: "#000",   // âœ… font color
    }} > */}
            <button
              className="allsubmitebutton flex items-center justify-center"
              style={{
                width: "53px",
                height: "30px",
                borderRadius: "6px",
              }}
              type="submit"
              onClick={(e) => {
                e.stopPropagation();
                addFavouriteFilter({
                  name: favName,
                  icon: selectedIcon,
                });
                // clear after save
                setFavName("");
                setSelectedIcon("");
              }}
            >
              Save
            </button>

            {/* </Tooltip > */}
          </div>
        </div>
      </div>
    </div>
  );
  // Table Columns
  const columns = [
    ...(authData?.roleId?.roleId === 1
      ? [
          {
            title: "#",
            dataIndex: "taskId",
            key: "taskId",
            fixed: "left" as const,
            // render: (_, __, index) => index + 1,
          },
        ]
      : []),
    {
      title: "Title",
      dataIndex: "taskName",
      key: "taskName",
      fixed: "left" as const,
      sorter: (a: any, b: any) => {
        const aText = a.taskName?.toLowerCase() || "";
        const bText = b.taskName?.toLowerCase() || "";
        return aText.localeCompare(bText);
      },
      render: (text: string) => {
        const words = text?.trim().split(/s+/);
        const isLong = words?.length > 2;
        const shortTitle = isLong ? `${words.slice(0, 2).join(" ")}...` : text;
        const content = (
          <div className="text-gray-800 hover:text-black ">{shortTitle}</div>
        );
        return isLong ? (
          <Tooltip
            title={text}
            placement="topLeft"
            color="#CCCCCC"
            overlayInnerStyle={{
              color: "#000", // âœ… font color
              padding: "12px",
              maxWidth: "500px",
              minWidth: "400px",
              maxHeight: "400px",
            }}
          >
            <div className="flex items-start gap-2 text-gray-700 hover:text-black cursor-pointer">
              {content}
            </div>
          </Tooltip>
        ) : (
          content
        );
      },
    },
    {
      title: "Task Description",
      dataIndex: "taskDesc",
      key: "taskDesc",
      fixed: "left" as const,
      sorter: (a: any, b: any) => {
        const plain = (html: string) =>
          String(html || "")
            .replace(/<img\b[^>]*>/gi, "")
            .replace(/<[^>]+>/g, "")
            .trim()
            .toLowerCase();
        return plain(a.taskDesc).localeCompare(plain(b.taskDesc));
      },
      render: (html: string) => {
        if (!html) return <span className="text-gray-400">N/A</span>;

        // Detect if HTML contains any <img> tags
        const hasImage = /<img\b[^>]*>/i.test(html);

        // Remove image tags for inline table display
        const htmlWithoutImages = html.replace(/<img\b[^>]*>/gi, "");

        // Convert to plain text (no HTML)
        const plainText = htmlWithoutImages.replace(/<[^>]+>/g, "").trim();

        // âœ… Limit by character count instead of words
        const maxChars = 30; // you can adjust this (e.g. 80, 100)
        const isLong = plainText.length > maxChars;

        const displayText = isLong
          ? plainText.slice(0, maxChars) + "..."
          : plainText;

        // âœ… Tooltip shows the original HTML (with images)
        const tooltipHtml = getPreviewableTooltipHtml(html);
        const tooltipContent = (
          <div
            className="description-tooltip-content"
            onClick={handleDescriptionImagePreview}
            dangerouslySetInnerHTML={{ __html: tooltipHtml }}
          />
        );

        // âœ… Cell content: truncated text only (no images)
        const cellContent = (
          <span
            className="text-gray-800 hover:text-black cursor-pointer line-clamp-1"
            dangerouslySetInnerHTML={{
              __html: displayText,
            }}
          />
        );

        const shouldShowTooltip = isLong || hasImage;

        return shouldShowTooltip ? (
          <Tooltip
            title={tooltipContent}
            placement="top"
            color="#CCCCCC"
            classNames={{ root: "plain-tooltip" }}
            overlayInnerStyle={{
              maxWidth: "500px",
              minWidth: "400px",
              maxHeight: "400px",
            }}
          >
            {cellContent}
          </Tooltip>
        ) : (
          cellContent
        );
      },
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      sorter: (a: any, b: any) => {
        const aDate = a.startDate ? new Date(a.startDate).getTime() : 0;
        const bDate = b.startDate ? new Date(b.startDate).getTime() : 0;
        return aDate - bDate;
      },
      render: (date: any) =>
        date ? (
          <div>
            {dayjs(date).format("DD-MM-YYYY")}
            <div className="text-xs text-blue-500">
              {dayjs(date).format("hh:mm A")}
            </div>
          </div>
        ) : (
          "-"
        ),
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      sorter: (a: any, b: any) => {
        const aDate = a.endDate ? new Date(a.endDate).getTime() : 0;
        const bDate = b.endDate ? new Date(b.endDate).getTime() : 0;
        return aDate - bDate;
      },
      render: (date: any) =>
        date ? (
          <div>
            {dayjs(date).format("DD-MM-YYYY")}

            <div className="text-xs text-blue-500">
              {dayjs(date).format("hh:mm A")}
            </div>
          </div>
        ) : (
          "-"
        ),
    },

    {
      title: "Deadline Date",
      dataIndex: "deadlineDate",
      key: "deadlineDate",
      sorter: (a: any, b: any) => {
        const aDate = a.deadlineDate ? new Date(a.deadlineDate).getTime() : 0;
        const bDate = b.deadlineDate ? new Date(b.deadlineDate).getTime() : 0;
        return aDate - bDate;
      },
      render: (date: any, record: any) => {
        const isOverdue =
          date && dayjs(date).isBefore(dayjs(), "minute") && !record.endDate;
        const formattedDate = date ? (
          <div>
            <span
              style={{
                color: isOverdue ? "#f44336" : "inherit",
                fontWeight: isOverdue ? 500 : "normal",
              }}
            >
              {dayjs(date).format("DD-MM-YYYY")}
            </span>
            <div className="text-xs text-blue-500">
              {dayjs(date).format("hh:mm A")}
            </div>
          </div>
        ) : (
          "-"
        );
        return formattedDate;
      },
    },
    {
      title: "Status",
      dataIndex: "boardId",
      key: "boardId",
      render: (board: any, record: any) => {
        const getBoardColor = (slug: string) => {
          const colors: Record<string, string> = {
            "to-do": "#f5b849",
            "in-progress": "#23b7e5",
            completed: "#26bf94",
            review: "#b26be0",
            hold: "#ff6b6b",
            default: "#888",
          };
          return colors[slug] || colors.default;
        };
        // Get current status - handle both object and string formats
        const currentStatus =
          typeof record.status === "string"
            ? record.status
            : record.status?.slug || "";
        // Get current board ID - handle both object and string formats
        const currentBoardId =
          typeof record.boardId === "string"
            ? record.boardId
            : record.boardId?._id || "";
        return (
          <Select
            value={currentBoardId}
            onChange={(value) => {
              handleUpdate(record._id, "boardId", value, "Status");
            }}
            className="custom-status-select"
            style={{ width: "110px" }}
            dropdownClassName="custom-status-dropdown"
            bordered={false}
            suffixIcon={null}
          >
            {boards
              ?.filter((board: any) => board.isActive && !board.isDeleted)
              .map((board: any) => (
                <Select.Option key={board._id} value={board._id}>
                  <div className="flex items-center gap-2">
                    <span
                      className=""
                      style={{
                        color: getBoardColor(board.slug),
                        fontSize: "14px",
                        width: "10px",
                      }}
                    >
                      {board.name}
                    </span>
                  </div>
                </Select.Option>
              ))}
          </Select>
        );
      },
    },
    {
      title: "Priority",
      dataIndex: "priority",
      key: "priority",
      sorter: (a: any, b: any) => {
        // Create priority order mapping with proper typing
        const priorityOrder: Record<string, number> = {
          High: 3,
          Medium: 2,
          Low: 1,
        };

        const aPriority = a.priority as string;
        const bPriority = b.priority as string;

        const aOrder = priorityOrder[aPriority] || 0;
        const bOrder = priorityOrder[bPriority] || 0;

        return aOrder - bOrder;
      },
      // width: 10,
      render: (text: string, record: any) => (
        <Select
          value={text}
          onChange={(value) =>
            handleUpdate(record._id, "priority", value, "Priority")
          }
          className="w-full custom-priority-select"
          dropdownStyle={{ width: "10%" }}
          dropdownClassName="custom-priority-dropdown"
          bordered={false}
          suffixIcon={null}
        >
          <Select.Option value="Low">
            <div className="flex items-center gap-2">
              {/* <span className="w-2 h-2 rounded-full bg-purple-400" / > */}

              <span className="text-[#26bf94] font-medium">Low</span>
            </div>
          </Select.Option>

          <Select.Option value="Medium">
            <div className="flex items-center gap-2">
              {/* <span className="w-2 h-2 rounded-full bg-orange-400" / > */}
              <span className="text-[#23b7e5] font-medium">Medium</span>
            </div>
          </Select.Option>

          <Select.Option value="High">
            <div className="flex items-center gap-2">
              {/* <span className="w-2 h-2 rounded-full bg-rose-500" / > */}
              <span className="text-[#e6533c] font-medium">High</span>
            </div>
          </Select.Option>
        </Select>
      ),
    },

    {
      title: "Reporter",
      dataIndex: "reporterId",
      key: "reporterId",
      render: (reporter: any) => reporter?.username || "-", // Ensure it correctly fetches firstName
    },

    {
      title: "Task Log",
      key: "taskLog",
      render: (_: any, record: any) => (
        <Tooltip title="View Logs">
          <button
            onClick={(e) => {
              e.preventDefault();
              handleViewLogs(record._id);
            }}
            className="w-7 h-7 rounded-full bg-gradient-to-br from-indigo-400 to-blue-600 shadow-[0_4px_12px_rgba(96,165,250,0.3)] hover:shadow-[0_6px_16px_rgba(96,165,250,0.4)] active:translate-y-1 active:shadow-none text-white flex items-center justify-center transition-all duration-200 group"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              className="group-hover:scale-110 transition-transform"
            >
              <path
                d="M6 4V20M18 4V20M6 4H18M6 20H18M9 8H15M9 12H15M9 16H13"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </Tooltip>
      ),
    },

    {
      title: "Action",
      key: "action",
      render: (_: any, record: any) => (
        <div className="flex items-center gap-3">
          {/* Edit Button - Enhanced */}
          <Tooltip title="Edit">
            <button
              onClick={() => handleEditTask(record)}
              className="w-7 h-7 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 
                         shadow-[0_4px_12px_rgba(139,92,246,0.3)] 
                         hover:shadow-[0_6px_16px_rgba(139,92,246,0.4)] 
                         active:translate-y-[1px] active:shadow-none 
                         text-white flex items-center justify-center 
                         transition-all duration-200 ease-in-out group"
            >
              <FaPen
                className="group-hover:scale-110 transition-transform duration-200"
                size={12}
              />
            </button>
          </Tooltip>

          {/* Delete Button - Enhanced */}

          <Tooltip title="Delete">
            <button
              onClick={() => handleDeleteConfirmation(record._id)}
              className="w-7 h-7 rounded-full bg-gradient-to-br from-rose-500 to-rose-700
            shadow-[0_4px_12px_rgba(244,63,94,0.3)]
            hover:shadow-[0_6px_16px_rgba(244,63,94,0.4)]
            active:translate-y-1 active:shadow-none
            text-white flex items-center justify-center
            transition-all duration-200 group"
            >
              <FaTrashAlt
                className="group-hover:scale-110 transition-transform"
                size={12}
              />
            </button>
          </Tooltip>
        </div>
      ),
    },
  ];

  useEffect(() => {
    autoRegisterCurrentPageColumns(columns);
  }, []);

  const menuItems = [
    {
      key: "table",
      label: (
        <div className="flex items-center gap-2 px-2 py-1 rounded-md group transition-all">
          <div className="w-7 h-7 flex items-center justify-center rounded-md bg-[#001529] text-white group-hover:bg-[#112240] shadow-sm transition-all">
            <ListTodo size={16} />
          </div>
          <span className="text-sm text-gray-800 font-medium">Table View</span>
        </div>
      ),

      onClick: () => navigate("/tasks"),
    },

    {
      key: "card",
      label: (
        <div className="flex items-center gap-2 px-2 py-1 rounded-md group transition-all">
          <div className="w-7 h-7 flex items-center justify-center rounded-md bg-[#001529] text-white group-hover:bg-[#112240] shadow-sm transition-all">
            <LayoutDashboard size={16} />
          </div>
          <span className="text-sm text-gray-800 font-medium">Card View</span>
        </div>
      ),
      onClick: () => navigate("/task"),
    },
  ];

  const handleDeveloperSelect = (developerId: any) => {
    // Reset developer and pagination
    setSelectedDeveloper((prev) => (prev === developerId ? null : developerId));
    dispatch(updatePaginationCurrent(1)); // ðŸ‘ˆ Reset page to 1
    fetchDevelopers();
  };

  const handleDeveloperPaginationChange = (
    developerId: any,
    page: number,
    pageSize: number,
  ) => {
    dispatch(updateDeveloperPaginationCurrent({ developerId, current: page }));

    console.log("Active Devloper collapsed", activeFav);
    if (activeFav) {
      let deadlineDate;
      if (activeFav.deadlineDate === "custom") {
        deadlineDate = {
          type: "custom",
          startDate: activeFav.startDate,
          endDate: activeFav.endDate,
        };
      } else {
        deadlineDate = activeFav.deadlineDate;
      }

      fetchTasksHandler({
        isGroupBy: isGroupView && !taskId && isAdmin,
        searchText,
        statusFilter: activeFav?.board,
        deadlineDate: deadlineDate || activeFav.time,
        developerId: activeFav.assignees?.length
          ? activeFav.assignees[0]
          : developerId,
        page,
      });
    } else {
      // console.log(
      //   "Active Devloper collapsed developoer pagination",
      //   developerId
      // );
      fetchTasksHandler({
        isGroupBy: true,
        statusFilter: isAdmin ? undefined : statusFilter,
        deadlineDate: deadline || undefined,
        developerId: developerId,
        page,
        searchText,
      });
    }
  };

  const onDragEnd = async (result: any) => {
    if (result.type === "DEVELOPER") {
      handleDeveloperDragEnd(result);

      return;
    }
    if (result.type !== "TASK") return;
    const { source, destination, draggableId } = result;
    if (!destination) return;
    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    )
      return;
    if (isGroupView && !taskId && isAdmin) {
      // Grouped view logic
      const startDevId = source.droppableId;
      const finishDevId = destination.droppableId;
      // Create deep copies to avoid mutation
      const newLocalTasks = JSON.parse(JSON.stringify(localTasksByDeveloper));
      const startTasks = [...(newLocalTasks[startDevId] || [])];
      const movedTaskIndex = startTasks.findIndex(
        (t: any) => t._id === draggableId,
      );
      if (movedTaskIndex === -1) return;
      const [movedTask] = startTasks.splice(movedTaskIndex, 1);
      let updatedTask = { ...movedTask };
      const finishTasks =
        startDevId === finishDevId
          ? startTasks
          : [...(newLocalTasks[finishDevId] || [])];
      if (startDevId !== finishDevId) {
        const finishDeveloper = developerOptions.find(
          (d: any) => d._id === finishDevId,
        );
        if (!finishDeveloper) return;
        // Create new assignees array immutably
        const newAssignees = movedTask.assignees
          .filter((a: any) => a._id !== startDevId)
          .map((a: any) => ({ ...a }));
        if (!newAssignees.some((a: any) => a._id === finishDevId)) {
          newAssignees.push({ ...finishDeveloper });
        }
        // Update the task with new assignees
        updatedTask = {
          ...movedTask,
          assignees: newAssignees,
        };
        // Update Redux state
        dispatch(
          updateTaskLocal({
            taskId: draggableId,

            updates: { assignees: newAssignees },
          }),
        );

        try {
          // Make API call to update assignees - UNCOMMENT THIS
          await updateTask(draggableId, {
            assignees: newAssignees.map((a: any) => a._id) as any,
          });
        } catch (error) {
          console.error("Failed to update assignees", error);
          message.error("Failed to update task assignees");
          // Revert on error
          // console.log(" Fetch Task when the drag and drop")
          fetchTasksHandler({
            isGroupBy: true,
            statusFilter: getStatusFilter(),
            deadlineDate: deadline || undefined,
          });

          return;
        }
        // Update pagination counts
        setLocalDeveloperPaginations((prev: any) => ({
          ...prev,
          [startDevId]: {
            ...prev[startDevId],
            total: (prev[startDevId]?.total || 0) - 1,
          },
          [finishDevId]: {
            ...prev[finishDevId],
            total: (prev[finishDevId]?.total || 0) + 1,
          },
        }));
      }

      // Insert the updated task at the destination

      finishTasks.splice(destination.index, 0, updatedTask);
      // Update the local tasks state
      newLocalTasks[startDevId] = startTasks;
      newLocalTasks[finishDevId] = finishTasks;
      setLocalTasksByDeveloper(newLocalTasks);
      // Update task orders via API - FIXED THIS SECTION
      try {
        const orderUpdates = [];
        // Update orders for start developer tasks
        const startPagination = localDeveloperPaginations[startDevId] || {
          current: 1,
          pageSize: 5,
        };
        const startOffset =
          (startPagination.current - 1) * startPagination.pageSize;

        for (let i = 0; i < startTasks.length; i++) {
          orderUpdates.push({
            taskId: startTasks[i]._id,
            orderIndex: startOffset + i + 1,
          });
        }
        // Update orders for finish developer tasks
        const finishPagination = localDeveloperPaginations[finishDevId] || {
          current: 1,
          pageSize: 5,
        };

        const finishOffset =
          (finishPagination.current - 1) * finishPagination.pageSize;
        for (let i = 0; i < finishTasks.length; i++) {
          orderUpdates.push({
            taskId: finishTasks[i]._id,
            orderIndex: finishOffset + i + 1,
          });
        }

        // Send the order updates
        await updateTaskOrder(orderUpdates);
      } catch (error) {
        console.error("Failed to update order", error);
        message.error("Failed to update task order");
      }
    } else {
      // Flat view logic
      const newFiltered = [...localFilteredTasks];
      const oldIndex = newFiltered.findIndex(
        (item) => item._id === draggableId,
      );
      if (oldIndex === -1) return;
      const [moved] = newFiltered.splice(oldIndex, 1);
      newFiltered.splice(destination.index, 0, moved);
      setLocalFilteredTasks(newFiltered);
      dispatch(setFilteredTasks(newFiltered));
      try {
        // Prepare order updates for all tasks in the current page
        const orderUpdates = newFiltered.map((task, index) => ({
          taskId: task._id,
          orderIndex:
            (pagination.current - 1) * pagination.pageSize + index + 1,
        }));
        await updateTaskOrder(orderUpdates);
      } catch (error) {
        console.error("Failed to update order", error);
        message.error("Failed to update task order");
      }
    }
  };

  //   const onDragEnd = async (result: any) => {
  // if (result.type === "DEVELOPER") {
  //   handleDeveloperDragEnd(result);
  //   return;
  // }
  // if (result.type !== "TASK") return;
  // const { source, destination, draggableId } = result;
  // if (!destination) return;
  // if (source.droppableId === destination.droppableId && source.index === destination.index) return;
  // if (isGroupView && isAdmin) {
  //   // Grouped view logic
  //   const startDevId = source.droppableId;
  //   const finishDevId = destination.droppableId;
  //   // Create deep copies to avoid mutation
  //   const newLocalTasks = JSON.parse(JSON.stringify(localTasksByDeveloper));
  //   const startTasks = [...(newLocalTasks[startDevId] || [])];
  //   const movedTaskIndex = startTasks.findIndex((t: any) => t._id === draggableId);
  //   if (movedTaskIndex === -1) return;
  //   const [movedTask] = startTasks.splice(movedTaskIndex, 1);
  //   let updatedTask = { ...movedTask };
  //   const finishTasks = startDevId === finishDevId ? startTasks : [...(newLocalTasks[finishDevId] || [])];
  //   if (startDevId !== finishDevId) {
  //     const finishDeveloper = developerOptions.find((d: any) => d._id === finishDevId);
  //     if (!finishDeveloper) return;
  //     // Create new assignees array immutably
  //     const newAssignees = movedTask.assignees
  //       .filter((a: any) => a._id !== startDevId)
  //       .map((a: any) => ({ ...a })); // Create copies of assignee objects
  //     if (!newAssignees.some((a: any) => a._id === finishDevId)) {
  //       newAssignees.push({ ...finishDeveloper }); // Add copy of finish developer
  //     }
  //     // Update the task with new assignees
  //     updatedTask = {
  //       ...movedTask,
  //       assignees: newAssignees
  //     };
  //     // Update Redux state
  //     dispatch(updateTaskLocal({
  //       taskId: draggableId,
  //       updates: { assignees: newAssignees }
  //     }));
  //     try {
  //       // Make API call to update assignees
  //       // await updateTask(draggableId, { assignees: newAssignees.map(a => a._id) });
  //     } catch (error) {
  //       console.error("Failed to update assignees", error);
  //       message.error("Failed to update task assignees");
  //       // Revert on error
  //       fetchTasksHandler({
  //         isGroupBy: true,
  //         statusFilter: getStatusFilter(),
  //         deadlineDate: deadline || undefined,
  //       });
  //       return;
  //     }
  //     // Update pagination counts
  //     setLocalDeveloperPaginations((prev: any) => ({
  //       ...prev,
  //       [startDevId]: {
  //         ...prev[startDevId],
  //         total: (prev[startDevId]?.total || 0) - 1
  //       },
  //       [finishDevId]: {
  //         ...prev[finishDevId],
  //         total: (prev[finishDevId]?.total || 0) + 1
  //       },
  //     }));
  //   }
  //   // Insert the updated task at the destination
  //   finishTasks.splice(destination.index, 0, updatedTask);
  //   // Update the local tasks state
  //   newLocalTasks[startDevId] = startTasks;
  //   newLocalTasks[finishDevId] = finishTasks;
  //   setLocalTasksByDeveloper(newLocalTasks);
  //   // Update task orders via API
  //   try {
  //     const startPagination = localDeveloperPaginations[startDevId] || { current: 1, pageSize: 5 };
  //     const startOffset = (startPagination.current - 1) * startPagination.pageSize;
  //     const startReordered = startTasks.map((task: any, idx: number) => ({
  //       taskId: task._id,
  //       orderIndex: startOffset + idx + 1,
  //     }));
  //     const finishPagination = localDeveloperPaginations[finishDevId] || { current: 1, pageSize: 5 };
  //     const finishOffset = (finishPagination.current - 1) * finishPagination.pageSize;
  //     const finishReordered = finishTasks.map((task: any, idx: number) => ({
  //       taskId: task._id,
  //       orderIndex: finishOffset + idx + 1,
  //     }));
  //     await updateTaskOrder([...startReordered, ...finishReordered]);
  //     // Refresh to ensure consistency
  //     fetchTasksHandler({
  //       isGroupBy: true,
  //       statusFilter: getStatusFilter(),
  //       deadlineDate: deadline || undefined,
  //     });
  //   } catch (error) {
  //     console.error("Failed to update order", error);
  //     message.error("Failed to update task order");
  //     fetchTasksHandler({
  //       isGroupBy: true,
  //       statusFilter: getStatusFilter(),
  //       deadlineDate: deadline || undefined,
  //     });
  //   }
  // }  else {
  //     // Flat view logic
  //     const newFiltered = [...localFilteredTasks];
  //     const oldIndex = newFiltered.findIndex(item => item._id === draggableId);
  //     if (oldIndex === -1) return;
  //     const [moved] = newFiltered.splice(oldIndex, 1);
  //     newFiltered.splice(destination.index, 0, moved);
  //     setLocalFilteredTasks(newFiltered);
  //     dispatch(setFilteredTasks(newFiltered));
  //     const reorderedPayload = newFiltered.map((task, index) => ({
  //       taskId: task._id,
  //       orderIndex: (pagination.current - 1) * pagination.pageSize + index + 1,
  //     }));
  //     try {
  //       await updateTaskOrder(reorderedPayload);
  //       fetchTasksHandler({
  //         isGroupBy: false,
  //         statusFilter: getStatusFilter(),
  //         deadlineDate: deadline || undefined,
  //       });
  //     } catch (error) {
  //       console.error("Failed to update order", error);
  //       fetchTasksHandler({
  //         isGroupBy: false,
  //         statusFilter: getStatusFilter(),
  //         deadlineDate: deadline || undefined,
  //       });
  //     }
  //   }
  // };

  const groupMenuItems = [
    {
      key: "collapseExpand",
      label: (
        <span onClick={handleGroupExpandToggle}>
          {isGroupByExpanded ? "Collapse All" : "Expand All"}
        </span>
      ),
    },
    {
      key: "card",
      label: (
        <div className="flex items-center gap-2 px-2 py-1 rounded-md group transition-all">
          <div className="w-7 h-7 flex items-center justify-center rounded-md bg-[#001529] text-white group-hover:bg-[#112240] shadow-sm transition-all">
            <LayoutDashboard size={16} />
          </div>
          <span className="text-sm text-gray-800 font-medium">Card View</span>
        </div>
      ),
      onClick: () => navigate("/task"),
    },
    {
      key: "groupViewToggle",
      label: (
        <span
          onClick={() => {
            const newGroupView = !isGroupView;
            setIsGroupView(newGroupView);
            dispatch(updatePaginationCurrent(1));
            if (activeFav) {
              // console.log("Active Fav View", activeFav)
              fetchTasksHandler({
                isGroupBy: newGroupView,
                page: 1,
                statusFilter: activeFav?.board,
                developerId:
                  activeFav?.assignees?.[0] || selectedDeveloper || undefined,
                deadlineDate: activeFav?.time || undefined,
                searchText,
              });
            } else {
              // console.log("Active view Without Fav")
              fetchTasksHandler({
                isGroupBy: newGroupView,
                developerId: selectedDeveloper,
                deadlineDate: deadline || undefined,
                statusFilter: getStatusFilter(),
                page: 1,
                searchText,
              });
            }
          }}
        >
          {isGroupView ? (
            <div className="flex items-center gap-2 px-2 py-1 rounded-md group transition-all">
              <div className="w-7 h-7 flex items-center justify-center rounded-md bg-[#001529] text-white group-hover:bg-[#112240] shadow-sm transition-all">
                <Icons.TableOutlined size={16} />
              </div>
              <span className="text-sm text-gray-800 font-medium">
                Group View
              </span>
            </div>
          ) : (
            <div className="flex items-center gap-2 px-2 py-1 rounded-md group transition-all">
              <div className="w-7 h-7 flex items-center justify-center rounded-md bg-[#001529] text-white group-hover:bg-[#112240] shadow-sm transition-all">
                <Icons.PicRightOutlined size={16} />
              </div>
              <span className="text-sm text-gray-800 font-medium">
                Collapsed View
              </span>
            </div>
          )}
        </span>
      ),
    },
    {
      key: "addFilter",
      label: (
        <div
          onClick={() => setTaskModal(true)}
          className="flex items-center gap-2 px-2 py-1 rounded-md group cursor-pointer transition-all"
        >
          <div className="w-7 h-7 flex items-center justify-center rounded-md bg-[#001529] text-white group-hover:bg-[#112240] shadow-sm transition-all">
            <Icons.FilterOutlined size={16} />
          </div>
          <span className="text-sm text-gray-800 font-medium">Add Filters</span>
        </div>
      ),
    },
  ];

  return (
    <div>
      <>
        {/* ==================== NON-ADMIN ROW ==================== */}
        {!isAdmin && (
          <Row
            gutter={[12, 12]}
            align="middle"
            justify="space-between"
            wrap={false}
            className=" m-2"
          >
            <Col flex="none" className="min-w-[90px]">
              <h2 className="headername">Tasks</h2>
            </Col>

            <Col className="flex items-center gap-3 flex-wrap justify-end">
              {/* Views Dropdown */}
              <Dropdown
                overlay={<Menu items={menuItems} />}
                trigger={["click"]}
              >
                <Tooltip title="Views">
                  <button
                    className="w-9 h-9 rounded-full bg-[#001529] hover:bg-[#112240] 
                         transition duration-200 shadow-md flex items-center justify-center group"
                  >
                    <Layout
                      className="text-white group-hover:text-blue-300 transition-transform duration-200 group-hover:scale-110"
                      size={18}
                    />
                  </button>
                </Tooltip>
              </Dropdown>
              <Select
                value={userTimeFilter || undefined}
                onChange={(value, option) => {
                  const selectedValue = value as typeof userTimeFilter;
                  setUserTimeFilter(selectedValue);

                  if (selectedValue === "custom") {
                    const customOption = option as {
                      startDate?: string;
                      endDate?: string;
                    };
                    if (customOption?.startDate && customOption?.endDate) {
                      setUserStartDate(dayjs(customOption.startDate));
                      setUserEndDate(dayjs(customOption.endDate));
                    } else {
                      setShowRangePicker(true);
                    }
                  } else {
                    setUserStartDate(null);
                    setUserEndDate(null);
                    setTempUserStart(null);
                    setTempUserEnd(null);
                    setShowRangePicker(false);
                  }
                }}
                style={{ width: 150, height: "33px" }}
                placeholder="ðŸ“… Filter by date"
                // allowClear
                options={userTimeFilterOptions}
                optionLabelProp="label"
                dropdownRender={(menu) => (
                  <div>
                    {menu}
                    <div style={{ textAlign: "center", marginTop: 4 }}>
                      <Button
                        type="text"
                        style={{ color: "red", width: "100%" }}
                        onClick={() => {
                          setUserTimeFilter(null);
                          setUserStartDate(null);
                          setUserEndDate(null);
                          setTempUserStart(null);
                          setTempUserEnd(null);
                          setShowRangePicker(false);
                          fetchTasksHandler({
                            page: 1,
                            deadlineDate: undefined,
                          });
                        }}
                      >
                        Clear Filter
                      </Button>
                    </div>
                  </div>
                )}
              />

              {showRangePicker && (
                <div
                  style={{
                    position: "fixed",
                    top: "25%",
                    left: "70%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 1500,
                    background: "#fff",
                    padding: "16px",
                    boxShadow:
                      "0 3px 6px -4px rgba(0,0,0,0.12), 0 6px 16px 0 rgba(0,0,0,0.08), 0 9px 28px 8px rgba(0,0,0,0.05)",
                    borderRadius: "8px",
                    width: "fit-content",
                  }}
                >
                  <DatePicker.RangePicker
                    value={
                      tempUserStart && tempUserEnd
                        ? [tempUserStart, tempUserEnd]
                        : null
                    }
                    onChange={(dates) => {
                      setTempUserStart(dates ? dates[0] : null);
                      setTempUserEnd(dates ? dates[1] : null);
                    }}
                    format="YYYY-MM-DD"
                    style={{ marginBottom: "16px", width: "100%" }}
                    allowClear={false}
                    getPopupContainer={() => document.body}
                    popupStyle={{ zIndex: 2000 }}
                  />

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 8,
                    }}
                  >
                    <Button
                      onClick={() => {
                        setShowRangePicker(false);
                        setTempUserStart(null);
                        setTempUserEnd(null);
                        setUserTimeFilter(null);
                        setUserStartDate(null);
                        setUserEndDate(null);
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="allbuttons text-white deal-apply"
                      onClick={() => {
                        if (tempUserStart && tempUserEnd) {
                          setUserStartDate(tempUserStart);
                          setUserEndDate(tempUserEnd);
                          setShowRangePicker(false);
                          setUserTimeFilter("custom");
                        }
                      }}
                    >
                      Apply
                    </Button>
                  </div>
                </div>
              )}

              {/* Status Filter */}
              <Select
                mode="tags"
                style={{ width: 200, height: "33px" }}
                placeholder="Filter by status"
                value={statusFilter}
                onChange={handleStatusFilterChange}
                onInputKeyDown={handleKeyDown}
                options={getStatusOptions()}
                inputValue={inputValue}
                onSearch={(val) => setInputValue(val)}
                showSearch
                maxTagCount="responsive"
                className="min-w-[110px] asjdlaskjaslkd"
                tagRender={({ label, value, closable, onClose }) => (
                  <Tag closable={closable} onClose={onClose}>
                    {label}
                  </Tag>
                )}
              />

              {/* Search Input */}
              <Input
                prefix={<SearchOutlined />}
                placeholder="Search..."
                allowClear
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{ height: 33, width: 150 }}
              />

              {/* Add Button */}
              <Button
                type="primary"
                onClick={() => setIsAddTaskModalOpen(true)}
                className="allbuttons"
              >
                <RiAddBoxFill className="button-icon" />
                <span>Add</span>
              </Button>
            </Col>
          </Row>
        )}

        {/* ==================== ADMIN ROW ==================== */}
        {isAdmin && (
          <Row
            gutter={[12, 12]}
            align="middle"
            justify="space-between"
            wrap={false}
            className="m-2"
          >
            {/* LEFT â€” Favourite Filters */}
            <Col flex="auto" className="flex items-center">
              <Modal
                style={{
                  bottom: 20,
                  top: 20,
                  // maxHeight: 'calc(100vh - 30px)',
                  margin: "0 auto",
                  position: "relative",
                }}
                styles={{
                  body: {
                    overflowY: "auto",
                    fontFamily: "inter, sans-serif",
                  },
                  header: {
                    padding: "12px",
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f1f5ffff",
                  },
                  content: {
                    padding: 0,
                    overflow: "hidden",
                  },
                }}
                title={
                  <div
                    style={{
                      color: "#4b5563",
                      fontFamily: "inter, sans-serif",
                      fontSize: "20px",
                      fontWeight: 500,
                    }}
                  >
                    Task Favourite Filter
                  </div>
                }
                open={TaskModal}
                onCancel={(e) => {
                  (e.stopPropagation(), setTaskModal(false));
                  resetSettings();
                }}
                footer={null}
                width={650}
              >
                <div
                  onClick={(e) => e.stopPropagation()}
                  onMouseDown={(e) => e.stopPropagation()} // also block submenu toggling
                >
                  {TaskMenu}
                </div>
              </Modal>
              <div className="relative w-[500px] flex items-center rounded-l-md overflow-hidden">
                {canScrollLeft && (
                  <div
                    className="absolute left-0 z-10 flex items-center mt-[-14px]"
                    onClick={() => scroll("left")}
                  >
                    <Icons.LeftOutlined className="text-gray-500 text-lg cursor-pointer" />
                  </div>
                )}

                <div
                  ref={scrollRef}
                  className="flex overflow-x-auto scrollbar w-full snap-x snap-mandatory"
                  style={{ scrollBehavior: "smooth" }}
                >
                  {favouriteFilters.map((f: any, index: number) => {
                    const isActive = selectedFav === f._id;
                    const maxWords = 2;
                    const words = f.name.split(" ");
                    const isLong = words.length > maxWords;
                    const displayText = isLong
                      ? words.slice(0, maxWords).join(" ") + "..."
                      : f.name;

                    const tabContent = (
                      <div
                        key={f._id}
                        onClick={() => applyFavouriteFilter(f)}
                        className={`flex-0 snap-start flex-shrink-0 text-center cursor-pointer font-medium px-2 py-2 whitespace-nowrap overflow-hidden text-ellipsis ${
                          isActive
                            ? "bg-[#001529] text-white"
                            : "bg-white text-gray-700"
                        }`}
                        style={{
                          width: "calc(100% / 4)",
                          minWidth: "0",
                          borderRight:
                            index !== favouriteFilters.length - 1
                              ? "1px solid #e5e7eb"
                              : "none",
                        }}
                      >
                        {displayText}
                      </div>
                    );

                    return isLong ? (
                      <Tooltip key={f._id} title={f.name}>
                        {tabContent}
                      </Tooltip>
                    ) : (
                      tabContent
                    );
                  })}
                </div>

                {canScrollRight && (
                  <div
                    className="absolute right-0 z-10 mt-[-14px] flex items-center"
                    onClick={() => scroll("right")}
                  >
                    <Icons.RightOutlined className="text-gray-500 text-lg cursor-pointer" />
                  </div>
                )}
              </div>
            </Col>

            {/* RIGHT â€” Search, Avatars, Add */}
            <Col flex="none">
              <div className="flex items-center gap-3 mr-2">
                <div className="flex items-center space-x-[-10px] ">
                  {developerOptions.slice(0, 6).map((developer) => (
                    <Tooltip title={developer.username} key={developer._id}>
                      <div
                        className={`w-8 h-8 rounded-full border-2 ${
                          selectedDeveloper === developer._id
                            ? "border-blue-500 ring-2 ring-blue-300"
                            : "border-white"
                        } overflow-hidden transition-transform hover:z-10 hover:scale-110 cursor-pointer -ml-2 first:ml-0 z-0`}
                        onClick={() =>
                          handleDeveloperSelect(
                            selectedDeveloper === developer._id
                              ? null
                              : developer._id,
                          )
                        }
                      >
                        {developer.photo ? (
                          <img
                            src={`${IMAGEURL}/${developer.photo}`}
                            alt={developer.username}
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <div className="bg-gray-300 w-full h-full flex items-center justify-center text-xs font-bold text-white">
                            {developer.username?.trim().charAt(0).toUpperCase()}
                          </div>
                        )}
                      </div>
                    </Tooltip>
                  ))}

                  {/* Extra Developers Dropdown */}

                  {developerOptions.length > 6 && (
                    <Dropdown
                      overlay={
                        <div className="bg-white border border-gray-200 rounded-md shadow-lg p-2 w-64 max-h-80 overflow-y-auto">
                          {developerOptions.slice(6).map((developer) => (
                            <div
                              key={developer._id}
                              className={`flex items-center space-x-2 py-2 px-3 rounded cursor-pointer hover:bg-gray-100 ${
                                selectedDeveloper === developer._id
                                  ? "bg-blue-50"
                                  : ""
                              }`}
                              onClick={() =>
                                handleDeveloperSelect(
                                  selectedDeveloper === developer._id
                                    ? null
                                    : developer._id,
                                )
                              }
                            >
                              {developer.photo ? (
                                <img
                                  src={`${IMAGEURL}/${developer.photo}`}
                                  alt={developer.username}
                                  className="w-6 h-6 rounded-full object-cover"
                                />
                              ) : (
                                <div className="w-6 h-6 rounded-full bg-gray-300 flex items-center justify-center text-xs font-bold text-white">
                                  {developer.username
                                    ?.trim()
                                    .charAt(0)
                                    .toUpperCase()}
                                </div>
                              )}

                              <span className="text-sm text-gray-700 flex-grow">
                                {developer.username}
                              </span>

                              {selectedDeveloper === developer._id && (
                                <span className="text-blue-500">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-4 w-4"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </span>
                              )}
                            </div>
                          ))}
                        </div>
                      }
                      trigger={["click"]}
                      placement="bottomRight"
                    >
                      <div className="w-8 h-8 rounded-full bg-gray-200 text-gray-600 text-xs font-semibold flex items-center justify-center border-2 border-white cursor-pointer hover:bg-gray-300">
                        +{developerOptions.length - 6}
                      </div>
                    </Dropdown>
                  )}

                  {selectedDeveloper && (
                    <div className="flex items-center pl-4 first:ml-0 relative group">
                      <Tooltip
                        title="Clear Selection"
                        color="#CCCCCC"
                        overlayInnerStyle={{
                          color: "#000", // âœ… font color

                          padding: "12px",
                        }}
                      >
                        <div
                          className="w-8 h-8 rounded-full border-2 border-blue-500 ring-2 ring-blue-300 overflow-hidden cursor-pointer"
                          onClick={() => handleDeveloperSelect(null)}
                        >
                          {(() => {
                            const developer = developerOptions.find(
                              (dev) => dev._id === selectedDeveloper,
                            );
                            if (!developer) return null;
                            return developer.photo ? (
                              <img
                                src={`${IMAGEURL}/${developer.photo}`}
                                alt={developer.username}
                                className="w-full h-full object-cover"
                              />
                            ) : (
                              <div className="bg-gray-300 w-full h-full flex items-center justify-center text-xs font-bold text-white">
                                {developer.username
                                  ?.trim()
                                  .charAt(0)
                                  .toUpperCase()}
                              </div>
                            );
                          })()}
                        </div>
                      </Tooltip>

                      {/* Close Button Overlay */}

                      <button
                        onClick={() => handleDeveloperSelect(null)}
                        className="absolute -top-1 -right-1 w-4 h-4 bg-white text-gray-600 rounded-full flex items-center justify-center text-xs border border-gray-300 shadow hover:bg-gray-100"
                      >
                        Ã—
                      </button>
                    </div>
                  )}
                </div>
                <div className="flex ">
                  {/* Search */}
                  <Input
                    prefix={<SearchOutlined />}
                    placeholder="Search..."
                    allowClear
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    style={{
                      height: 33,
                      width: 150,
                      borderTopRightRadius: 2,
                      borderBottomRightRadius: 2,
                    }}
                  />
                  <Dropdown
                    overlay={<Menu items={groupMenuItems} />}
                    trigger={["click"]}
                  >
                    <Button
                      style={{
                        height: 33,
                        width: 40,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderTopLeftRadius: 2,
                        borderBottomLeftRadius: 2,
                      }}
                      icon={<AppstoreOutlined />}
                    />
                  </Dropdown>
                </div>

                {/* Add Task Button */}
                <Button
                  type="primary"
                  onClick={() => setIsAddTaskModalOpen(true)}
                  className="allbuttons"
                >
                  <RiAddBoxFill className="button-icon" />
                  <span>Add</span>
                </Button>
              </div>
            </Col>
          </Row>
        )}
      </>

      {/* Developers Table */}

      <Spin spinning={loading} style={{ textAlign: "center" }}>
        {isGroupView && !taskId && isAdmin ? (
          <Card className="w-100">
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="developer-list" type="DEVELOPER">
                {(provided) => (
                  <div
                    className="bg-white rounded-md"
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                  >
                    {(!selectedDeveloper
                      ? [...developerOptions]
                          .filter((dev) => {
                            // âœ… If searching, completely hide developers who have 0 matching tasks
                            if (searchText) {
                              const count =
                                localDeveloperPaginations[dev._id]?.total || 0;
                              return count > 0;
                            }
                            return true; // If not searching, show everyone normally
                          })
                          .sort((a, b) => {
                            // âœ… If searching, pull developers with the most tasks to the top!
                            if (searchText) {
                              const countA =
                                localDeveloperPaginations[a._id]?.total || 0;
                              const countB =
                                localDeveloperPaginations[b._id]?.total || 0;
                              return countB - countA;
                            }
                            return 0; // Otherwise, keep their normal manual order
                          })
                      : developerOptions.filter(
                          (dev) => dev._id === selectedDeveloper,
                        )
                    ) // Final list after filtering and sorting
                      .map((developer, index) => {
                        const developerTasks =
                          localTasksByDeveloper[developer._id] || [];
                        const developerTasksWithSerial = developerTasks.map(
                          (task: any, index: any) => ({
                            ...task,

                            serialNumber: index + 1,
                          }),
                        );

                        return (
                          <Draggable
                            key={developer._id}
                            draggableId={developer._id}
                            index={index}
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                              >
                                <Collapse
                                  className="mb-2"
                                  activeKey={expandedKeys}
                                  onChange={(keys) => {
                                    setExpandedKeys(
                                      Array.isArray(keys) ? keys : [keys],
                                    );
                                  }}
                                >
                                  <Collapse.Panel
                                    key={developer._id}
                                    header={
                                      <div className="flex items-center justify-between w-full">
                                        {/* Left side - draggable part */}
                                        <div
                                          className="flex items-center gap-3"
                                          {...provided.dragHandleProps}
                                        >
                                          <Avatar
                                            size={32}
                                            src={
                                              developer.photo
                                                ? `${IMAGEURL}/${developer.photo}`
                                                : undefined
                                            }
                                            style={{
                                              backgroundColor: developer.photo
                                                ? "transparent"
                                                : "#7265e6",
                                            }}
                                          >
                                            {!developer.photo &&
                                              developer.username
                                                .charAt(0)
                                                .toUpperCase()}
                                          </Avatar>
                                          <span className="font-medium">
                                            {developer.username}
                                          </span>
                                          <span className="text-gray-500 text-sm">
                                            (
                                            {
                                              localDeveloperPaginations[
                                                developer._id
                                              ]?.total
                                            }{" "}
                                            tasks)
                                          </span>
                                        </div>

                                        {/* Right side - Transfer button */}
                                        <Tooltip title="Transfer all tasks to another employee">
                                          <Button
                                            type="text"
                                            size="small"
                                            icon={<SwapOutlined />}
                                            onClick={(e) => {
                                              e.stopPropagation(); // prevent collapse toggle
                                              openTransferModal(developer._id);
                                            }}
                                            className="text-gray-500 hover:text-blue-500"
                                          />
                                        </Tooltip>
                                      </div>
                                    }
                                  >
                                    <Droppable
                                      droppableId={developer._id}
                                      type="TASK"
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          ref={provided.innerRef}
                                          {...provided.droppableProps}
                                          className={`min-h-[60px] rounded-xl border border-dashed p-2 transition-colors ${
                                            snapshot.isDraggingOver
                                              ? "bg-blue-50 border-blue-300"
                                              : "bg-gray-50 border-gray-200"
                                          }`}
                                        >
                                          <Table
                                            key={`${developer._id}-table`}
                                            className="scrollbar-hide custom-scroll-table"
                                            columns={columns}
                                            dataSource={
                                              developerTasksWithSerial
                                            }
                                            rowKey="_id"
                                            scroll={{ x: "max-content" }}
                                            //@ts-ignore
                                            // onRow={(record: any, index: any) => ({
                                            //   index,
                                            //   'data-row-key': record._id,
                                            // })}
                                            // components={{ body: { row: DraggableRow } }}
                                            pagination={{
                                              current:
                                                localDeveloperPaginations[
                                                  developer._id
                                                ]?.current || 1,

                                              pageSize:
                                                localDeveloperPaginations[
                                                  developer._id
                                                ]?.pageSize || 5,

                                              total:
                                                localDeveloperPaginations[
                                                  developer._id
                                                ]?.total || 0,

                                              onChange: (page, pageSize) =>
                                                handleDeveloperPaginationChange(
                                                  developer._id,
                                                  page,
                                                  pageSize,
                                                ),

                                              showSizeChanger: false,
                                            }}
                                          />
                                          {provided.placeholder}
                                        </div>
                                      )}
                                    </Droppable>
                                  </Collapse.Panel>
                                </Collapse>
                              </div>
                            )}
                          </Draggable>
                        );
                      })}

                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </Card>
        ) : (
          <Card className="w-100">
            <>
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="tasks" type="TASK">
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      className={`min-h-[60px] rounded-xl border border-dashed p-2 transition-colors ${
                        snapshot.isDraggingOver
                          ? "bg-blue-50 border-blue-300"
                          : "bg-gray-50 border-gray-200"
                      }`}
                    >
                      <Table
                        className="scrollbar-hide custom-scroll-table"
                        columns={[
                          {
                            title: "#",
                            dataIndex: "taskId",
                            key: "taskId",
                            fixed: "left" as const,
                            // render: (_, __, index) => index + 1,
                          },

                          {
                            title: "Assignees",
                            dataIndex: "assignees",
                            key: "assignees",
                            fixed: "left" as const,
                            render: (assignees: any[], record: any) => {
                              const visibleAssignees = assignees.slice(0, 2);
                              const hiddenAssignees =
                                assignees.length > 2 ? assignees.slice(2) : [];
                              const handleChange = (
                                selectedAssignees: string[],
                              ) => {
                                // Map ids back to developer objects
                                const fullAssignees = developerOptions.filter(
                                  (dev) => selectedAssignees.includes(dev._id),
                                );
                                handleUpdate(
                                  record._id,
                                  "assignees",
                                  fullAssignees,
                                  "Assignees",
                                );
                              };

                              return (
                                <Dropdown
                                  trigger={["click"]}
                                  dropdownRender={() => (
                                    <div className="p-2 rounded-lg shadow-lg bg-white max-h-64 overflow-y-auto">
                                      {developerOptions.map((dev: any) => {
                                        const isSelected = assignees.some(
                                          (a) => a._id === dev._id,
                                        );

                                        return (
                                          <div
                                            key={dev._id}
                                            onClick={() => {
                                              const newSelectedIds = isSelected
                                                ? assignees
                                                    .filter(
                                                      (a) => a._id !== dev._id,
                                                    )
                                                    .map((a) => a._id)
                                                : [
                                                    ...assignees.map(
                                                      (a) => a._id,
                                                    ),
                                                    dev._id,
                                                  ];

                                              handleChange(newSelectedIds);
                                            }}
                                            className={`flex items-center px-3 py-2 rounded-md cursor-pointer transition ${
                                              isSelected
                                                ? "bg-gray-100"
                                                : "hover:bg-gray-50"
                                            }`}
                                          >
                                            <Avatar
                                              size="small"
                                              src={
                                                dev.photo
                                                  ? `${IMAGEURL}${dev.photo}`
                                                  : process.env.PUBLIC_URL +
                                                    "/download.png"
                                              }
                                              style={{
                                                backgroundColor: dev.photo
                                                  ? "transparent"
                                                  : "#7265e6",

                                                marginRight: 8,
                                              }}
                                            >
                                              {!dev.photo &&
                                                dev.username
                                                  ?.charAt(0)
                                                  .toUpperCase()}
                                            </Avatar>
                                            <span className="text-sm text-gray-800">
                                              {dev.username}
                                            </span>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  )}
                                >
                                  <div className="flex items-center gap-1 cursor-pointer">
                                    {/* First two assignees */}

                                    {visibleAssignees.map((assignee) => (
                                      <Tooltip
                                        title={assignee.username || "Unknown"}
                                        placement="top"
                                        key={assignee._id}
                                        color="#CCCCCC"
                                        overlayInnerStyle={{
                                          color: "#000", // âœ… font color
                                          padding: "12px",
                                        }}
                                      >
                                        <Avatar
                                          size="small"
                                          src={
                                            assignee.photo
                                              ? `${IMAGEURL}${assignee.photo}`
                                              : undefined
                                          }
                                          style={{
                                            backgroundColor: assignee.photo
                                              ? "transparent"
                                              : "#7265e6",
                                            cursor: "pointer",
                                          }}
                                        >
                                          {!assignee.photo &&
                                            assignee.username
                                              ?.charAt(0)
                                              .toUpperCase()}
                                        </Avatar>
                                      </Tooltip>
                                    ))}

                                    {/* "+N" dot for overflow */}

                                    {hiddenAssignees.length > 0 && (
                                      <Tooltip
                                        color="#CCCCCC"
                                        overlayInnerStyle={{
                                          color: "#000", // âœ… font color
                                          padding: "12px",
                                        }}
                                        title={
                                          <div className="flex flex-col gap-2">
                                            {hiddenAssignees.map((assignee) => (
                                              <div
                                                key={assignee._id}
                                                className="flex items-center gap-2"
                                              >
                                                <Avatar
                                                  size="small"
                                                  src={
                                                    assignee.photo
                                                      ? `${IMAGEURL}${assignee.photo}`
                                                      : undefined
                                                  }
                                                  style={{
                                                    backgroundColor:
                                                      assignee.photo
                                                        ? "transparent"
                                                        : "#7265e6",
                                                  }}
                                                >
                                                  {!assignee.photo &&
                                                    assignee.username
                                                      ?.charAt(0)
                                                      .toUpperCase()}
                                                </Avatar>

                                                <span>{assignee.username}</span>
                                              </div>
                                            ))}
                                          </div>
                                        }
                                        placement="top"
                                      >
                                        <Avatar
                                          size="small"
                                          style={{
                                            backgroundColor: "#d9d9d9",
                                            fontSize: 12,
                                            cursor: "pointer",
                                          }}
                                        >
                                          +{hiddenAssignees.length}
                                        </Avatar>
                                      </Tooltip>
                                    )}
                                    {/* Dropdown arrow */}
                                    <DownOutlined
                                      style={{
                                        fontSize: 10,
                                        color: "#888",
                                        marginLeft: 4,
                                      }}
                                    />
                                  </div>
                                </Dropdown>
                              );
                            },
                          },
                          ...columns,
                        ]}
                        dataSource={localFilteredTasks.filter(
                          (item) => item && item._id,
                        )}
                        rowKey="_id"
                        scroll={{ x: "max-content" }}
                        //@ts-ignore
                        // onRow={(record : any, index : any ) => ({
                        //   index,
                        //   'data-row-key': record._id,
                        // })}
                        // components={{ body: { row: DraggableRow } }}
                        pagination={{
                          current: pagination.current,
                          pageSize: 10,
                          total: pagination.total,
                          showSizeChanger: false,
                          onChange: (page) => {
                            dispatch(updatePaginationCurrent(page));

                            // --- COMMON LOGIC ---
                            const statusFilter = activeFav?.board;

                            const developerId = activeFav?.assignees?.length
                              ? activeFav.assignees[0]
                              : selectedDeveloper;

                            let deadlineDate: any = null;

                            // --- ADMIN / FAV LOGIC ---
                            if (isAdmin) {
                              if (activeFav?.time === "custom") {
                                deadlineDate = {
                                  type: "custom",
                                  startDate: activeFav.startDate,
                                  endDate: activeFav.endDate,
                                };
                              } else {
                                deadlineDate = activeFav?.time || undefined;
                              }

                              fetchTasksHandler({
                                isGroupBy: isGroupView && !taskId && isAdmin,
                                deadlineDate,
                                page,
                                developerId,
                                statusFilter: statusFilter,
                                startDate: activeFav?.startDate,
                                endDate: activeFav?.endDate,
                              });
                            }

                            // --- USER LOGIC ---
                            else {
                              let userDeadlineDate: any = null;

                              if (
                                userTimeFilter === "custom" &&
                                userStartDate &&
                                userEndDate
                              ) {
                                userDeadlineDate = {
                                  type: "custom",
                                  startDate: userStartDate.format("YYYY-MM-DD"),
                                  endDate: userEndDate.format("YYYY-MM-DD"),
                                };
                              } else {
                                userDeadlineDate = userTimeFilter; // default fallback
                              }

                              fetchTasksHandler({
                                isGroupBy: false,
                                deadlineDate: userDeadlineDate,
                                page,
                                developerId,
                                statusFilter: getStatusFilter(),
                              });
                            }
                          },
                        }}
                      />

                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </>
          </Card>
        )}
      </Spin>

      {/* Delete Confirmation Modal */}

      <Modal
        open={!!deleteId}
        onOk={handleDelete}
        onCancel={() => setDeleteId(null)}
        okText="Yes"
        cancelText="No"
        // footer={null}
        width={500}
        centered={false}
        destroyOnClose
        className="custom-modal"
        style={{
          bottom: 20,
          top: "10vw",
          maxHeight: "calc(100vh - 30px)",
          margin: "0 auto",
          position: "relative",
        }}
        title={
          <div
            style={{
              marginLeft: "11px",
              width: "100%",
              paddingRight: 20,
            }}
          >
            Confirmation
          </div>
        }
        okButtonProps={{
          style: {
            backgroundColor: "#ff4d4f",
            borderColor: "#ff4d4f",
            color: "white",
          },
        }}
        bodyStyle={{
          padding: "22px",
          overflowY: "auto",
          fontFamily: "inter, sans-serif",
        }}
        styles={{
          header: {
            borderBottom: "1px solid #e0e0e0",
            padding: "12px",
            position: "sticky",
            top: 0,
            backgroundColor: "white",
          },

          content: {
            padding: 0,
            overflow: "hidden",
          },

          footer: {
            borderTop: "1px solid #e0e0e0",
            padding: "12px",
            position: "sticky",
            top: 0,
            backgroundColor: "white",
          },
        }}
      >
        <p>Are you sure you want to delete this Task?</p>
      </Modal>

      {/* Task Log Modal */}

      <Modal
        title={
          <div className="flex justify-between items-center w-full">
            <span className="text-xl font-bold">Task Log</span>
            <Input
              placeholder="ðŸ” Search logs..."
              allowClear
              value={logSearchText}
              onChange={(e) => setLogSearchText(e.target.value)}
              className="w-64 rounded text-sm mr-10"
            />
          </div>
        }
        open={isLogModalOpen}
        onCancel={() => setIsLogModalOpen(false)}
        footer={null}
        width={650}
        style={{
          bottom: 20,
          top: 20,
          maxHeight: "calc(100vh - 30px)",
          margin: "0 auto",
          position: "relative",
        }}
        bodyStyle={{
          overflowY: "auto",

          fontFamily: "inter, sans-serif",
        }}
        styles={{
          header: {
            borderBottom: "1px solid #e0e0e0",
            padding: "12px",
            position: "sticky",
            top: 0,
            backgroundColor: "white",
          },
          content: {
            padding: 0,
            overflow: "hidden",
          },
        }}
      >
        <Spin spinning={logLoading}>
          <div ref={modalScrollRef} className="">
            <div className="elements">
              <table className="w-full bg-white shadow-md rounded-lg">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border p-3 text-left w-1/3">
                      <ClockCircleOutlined className="mr-2" /> Updated At
                    </th>
                    <th className="border p-3 text-left">
                      <MessageOutlined className="mr-2" /> Message
                    </th>
                  </tr>
                </thead>

                <tbody className="align-top bg-white relative z-0">
                  {selectedTaskLogs
                    .filter((log) =>
                      logSearchText
                        ? log.message
                            ?.toLowerCase()
                            .includes(logSearchText.toLowerCase())
                        : true,
                    )
                    .map((log, idx) => {
                      const formattedTimestamp = dayjs(log.createdAt)
                        .utc()
                        .local()
                        .format("DD-MM-YYYY HH:mm");

                      const htmlContent = log.message || "";
                      const tooltipHtmlContent =
                        getPreviewableTooltipHtml(htmlContent);

                      // Convert HTML â†’ plain text for length calculation
                      const tempDiv = document.createElement("div");
                      tempDiv.innerHTML = htmlContent;
                      const plainText =
                        tempDiv.textContent || tempDiv.innerText || "";

                      const needsTooltip =
                        plainText.length > 110 || htmlContent.includes("<li>");

                      const previewContent = (
                        <div
                          dangerouslySetInnerHTML={{ __html: htmlContent }}
                          className="description-preview"
                          style={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            // maxWidth: "350px",
                          }}
                        />
                      );

                      return (
                        <tr
                          key={log._id}
                          className="hover:bg-gray-100 transition"
                        >
                          <td className="border p-3">{formattedTimestamp}</td>

                          <td className="border p-3 max-w-xl align-top">
                            {needsTooltip ? (
                              <Tooltip
                                title={
                                  <div
                                    onClick={handleDescriptionImagePreview}
                                    dangerouslySetInnerHTML={{
                                      __html: tooltipHtmlContent,
                                    }}
                                    className="description-tooltip-content"
                                  />
                                }
                                mouseEnterDelay={0.3}
                                classNames={{ root: "plain-tooltip" }}
                                placement="top"
                                overlayStyle={{
                                  maxWidth: "500px",
                                  maxHeight: "400px",
                                  overflowY: "auto",
                                }}
                              >
                                <span style={{ cursor: "pointer" }}>
                                  {previewContent}
                                </span>
                              </Tooltip>
                            ) : (
                              <span style={{ cursor: "pointer" }}>
                                {previewContent}
                              </span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>

            <div className="footer-modals" />
            <div className="p-2">
              <div className="d-flex justify-content-end">
                <Pagination
                  current={logsPagination.current}
                  pageSize={logsPagination.pageSize}
                  total={logsPagination.total}
                  onChange={(page) => {
                    setLogLoading(true);
                    fetchLogs(currentTaskLogId, page).finally(() => {
                      setLogLoading(false);
                      setTimeout(() => {
                        modalScrollRef.current?.scrollTo({
                          top: 0,
                          behavior: "smooth",
                        });
                      }, 100);
                    });
                  }}
                  showSizeChanger={false}
                />
              </div>
            </div>
          </div>
        </Spin>
      </Modal>

      {/* Transfer Tasks Modal */}
      <Modal
        title={
          <div style={{ paddingTop: "8px" }}>
            <span style={{ fontWeight: 600, fontSize: 18 }}>
              Transfer Tasks
            </span>
          </div>
        }
        open={transferModalVisible}
        onCancel={() => {
          setTransferModalVisible(false);
          setCurrentDeveloperId(null);
          setSelectedTargetUserId(null);
        }}
        onOk={handleTransferConfirm}
        confirmLoading={transferLoading}
        okText="Transfer"
        cancelText="Cancel"
        okButtonProps={{ style: { backgroundColor: "#1677ff" } }}
        cancelButtonProps={{ style: { borderColor: "#d9d9d9" } }}
        width={480}
        centered
        styles={{
          body: { padding: "24px 24px 16px 24px" },
          footer: { padding: "12px 24px", borderTop: "1px solid #f0f0f0" },
          header: { padding: "20px 24px 8px 24px", borderBottom: "none" },
        }}
      >
        <div style={{ marginBottom: 24 }}>
          <span style={{ fontSize: 14, color: "#333" }}>
            Select an employee to receive all tasks from{" "}
            <strong style={{ color: "#1677ff" }}>
              {
                developerOptions.find((d) => d._id === currentDeveloperId)
                  ?.username
              }
            </strong>
            :
          </span>
        </div>

        <Select
          style={{ width: "100%" }}
          placeholder="Select employee"
          value={selectedTargetUserId}
          onChange={(val) => setSelectedTargetUserId(val)}
          options={developerOptions
            .filter((dev) => dev._id !== currentDeveloperId)
            .map((dev) => ({
              label: dev.username,
              value: dev._id,
            }))}
          size="large"
          showSearch
          optionFilterProp="label"
        />
      </Modal>

      {currentTask && (
        <EditTaskModal
          visible={isEditModalVisible}
          taskId={currentTask._id}
          onCancel={() => setIsEditModalVisible(false)}
          onSuccess={handleUpdateTask}
        />
      )}

      <TaskFormModal
        visible={isAddTaskModalOpen}
        onClose={() => setIsAddTaskModalOpen(false)}
        onTaskCreated={() => {
          setIsAddTaskModalOpen(false);
          fetchTasksHandler({ isGroupBy: isGroupView, page: 1 });
        }}
        // defaultBoardId={defaultBoardId}
      />
      {descriptionPreviewImage && (
        <Image
          src={descriptionPreviewImage}
          style={{ display: "none" }}
          preview={{
            visible: true,
            src: descriptionPreviewImage,
            rootClassName: "task-description-image-preview",
            closeIcon: (
              <CloseOutlined
                style={{
                  color: "#ffffff",
                  fontSize: 18,
                }}
              />
            ),
            onVisibleChange: (visible) => {
              if (!visible) {
                setDescriptionPreviewImage(null);
              }
            },
          }}
        />
      )}
    </div>
  );
};

export const TASK_TABLE_COLUMNS = [
  "taskName",
  "taskDesc",
  "startDate",
  "endDate",
  "deadlineDate",
  "boardId",
  "priority",
  "reporterId",
];

